/* eslint-disable */
// @ts-nocheck
/*
* This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
*/

import * as fm from "../../../../../fetch.pb"
import * as GoogleProtobufDuration from "../../../../../google/protobuf/duration.pb"
import * as GoogleProtobufEmpty from "../../../../../google/protobuf/empty.pb"
import * as GoogleProtobufStruct from "../../../../../google/protobuf/struct.pb"
import * as GoogleProtobufTimestamp from "../../../../../google/protobuf/timestamp.pb"
import * as AiH2oFeaturestoreApiV1DashboardApi from "./DashboardApi.pb"
import * as AiH2oFeaturestoreApiV1FeatureSetProtoApi from "./FeatureSetProtoApi.pb"
import * as AiH2oFeaturestoreApiV1FeatureSetSearch from "./FeatureSetSearch.pb"
import * as AiH2oFeaturestoreApiV1OnlineApi from "./OnlineApi.pb"
import * as AiH2oFeaturestoreApiV1RecommendationProtoApi from "./RecommendationProtoApi.pb"
import * as AiH2oFeaturestoreApiV1TimeToLiveApi from "./TimeToLiveApi.pb"

type Absent<T, K extends keyof T> = { [k in Exclude<keyof T, K>]?: undefined };
type OneOf<T> =
  | { [k in keyof T]?: undefined }
  | (
    keyof T extends infer K ?
      (K extends string & keyof T ? { [k in K]: T[K] } & Absent<T, K>
        : never)
    : never);

export enum JobType {
  Unknown = "Unknown",
  Ingest = "Ingest",
  Retrieve = "Retrieve",
  ExtractSchema = "ExtractSchema",
  ComputeStatistics = "ComputeStatistics",
  Revert = "Revert",
  MaterializationOnline = "MaterializationOnline",
  ComputeRecommendationClassifiers = "ComputeRecommendationClassifiers",
  Backfill = "Backfill",
  OptimizeStorage = "OptimizeStorage",
}

export enum PermissionType {
  Owner = "Owner",
  Editor = "Editor",
  Consumer = "Consumer",
  SensitiveConsumer = "SensitiveConsumer",
  Viewer = "Viewer",
}

export enum ActivePermission {
  ACTIVE_PERMISSION_NONE = "ACTIVE_PERMISSION_NONE",
  ACTIVE_PERMISSION_OWNER = "ACTIVE_PERMISSION_OWNER",
  ACTIVE_PERMISSION_EDITOR = "ACTIVE_PERMISSION_EDITOR",
  ACTIVE_PERMISSION_CONSUMER = "ACTIVE_PERMISSION_CONSUMER",
  ACTIVE_PERMISSION_SENSITIVE_CONSUMER = "ACTIVE_PERMISSION_SENSITIVE_CONSUMER",
  ACTIVE_PERMISSION_VIEWER = "ACTIVE_PERMISSION_VIEWER",
}

export enum ProjectAction {
  PROJECT_CREATED = "PROJECT_CREATED",
  PROJECT_UPDATED = "PROJECT_UPDATED",
}

export enum OfflineStorageFormat {
  OFFLINE_STORAGE_FORMAT_DELTA = "OFFLINE_STORAGE_FORMAT_DELTA",
  OFFLINE_STORAGE_FORMAT_SNOWFLAKE = "OFFLINE_STORAGE_FORMAT_SNOWFLAKE",
}

export enum JoinType {
  JOIN_TYPE_INNER = "JOIN_TYPE_INNER",
  JOIN_TYPE_LEFT = "JOIN_TYPE_LEFT",
  JOIN_TYPE_RIGHT = "JOIN_TYPE_RIGHT",
  JOIN_TYPE_FULL = "JOIN_TYPE_FULL",
  JOIN_TYPE_CROSS = "JOIN_TYPE_CROSS",
}

export enum FeatureFilterOperator {
  FEATURE_FILTER_OPERATOR_UNKNOWN = "FEATURE_FILTER_OPERATOR_UNKNOWN",
  FEATURE_FILTER_OPERATOR_EQ = "FEATURE_FILTER_OPERATOR_EQ",
  FEATURE_FILTER_OPERATOR_LT = "FEATURE_FILTER_OPERATOR_LT",
  FEATURE_FILTER_OPERATOR_LE = "FEATURE_FILTER_OPERATOR_LE",
  FEATURE_FILTER_OPERATOR_GT = "FEATURE_FILTER_OPERATOR_GT",
  FEATURE_FILTER_OPERATOR_GE = "FEATURE_FILTER_OPERATOR_GE",
  FEATURE_FILTER_OPERATOR_NE = "FEATURE_FILTER_OPERATOR_NE",
}

export enum FeatureFilterLogicOperator {
  FEATURE_FILTER_LOGIC_OPERATOR_UNKNOWN = "FEATURE_FILTER_LOGIC_OPERATOR_UNKNOWN",
  FEATURE_FILTER_LOGIC_OPERATOR_AND = "FEATURE_FILTER_LOGIC_OPERATOR_AND",
  FEATURE_FILTER_LOGIC_OPERATOR_OR = "FEATURE_FILTER_LOGIC_OPERATOR_OR",
}

export enum FeatureQueryJoinType {
  FEATURE_QUERY_JOIN_INNER = "FEATURE_QUERY_JOIN_INNER",
  FEATURE_QUERY_JOIN_LEFT = "FEATURE_QUERY_JOIN_LEFT",
}

export enum AccessModifier {
  ACCESS_MODIFIER_UNSPECIFIED = "ACCESS_MODIFIER_UNSPECIFIED",
  ACCESS_MODIFIER_PUBLIC = "ACCESS_MODIFIER_PUBLIC",
  ACCESS_MODIFIER_PROJECT_ONLY = "ACCESS_MODIFIER_PROJECT_ONLY",
  ACCESS_MODIFIER_PRIVATE = "ACCESS_MODIFIER_PRIVATE",
}

export enum FeatureDataType {
  TinyInt = "TinyInt",
  SmallInt = "SmallInt",
  BigInt = "BigInt",
  Int = "Int",
  Float = "Float",
  Double = "Double",
  String = "String",
  Binary = "Binary",
  Boolean = "Boolean",
  Date = "Date",
  Timestamp = "Timestamp",
}

export enum ProcessIntervalUnit {
  UNDEFINED = "UNDEFINED",
  HOURS = "HOURS",
  MONTHS = "MONTHS",
  DAYS = "DAYS",
  MINUTES = "MINUTES",
  SECONDS = "SECONDS",
  MILLISECONDS = "MILLISECONDS",
}

export enum TransformationType {
  TransformationUnknown = "TransformationUnknown",
  TransformationMojo = "TransformationMojo",
  TransformationSparkPipeline = "TransformationSparkPipeline",
}

export enum SortDirection {
  SORT_ASC = "SORT_ASC",
  SORT_DESC = "SORT_DESC",
}

export enum ResourceType {
  PROJECT = "PROJECT",
  FEATURE_SET = "FEATURE_SET",
}

export enum PermissionState {
  PENDING = "PENDING",
  GRANTED = "GRANTED",
  REJECTED = "REJECTED",
  REVOKED = "REVOKED",
  PROMOTED = "PROMOTED",
}

export enum TaskType {
  INGEST = "INGEST",
  LAZY_INGEST = "LAZY_INGEST",
}

export enum JobStatus {
  Created = "Created",
  Submitted = "Submitted",
  Running = "Running",
  SubmissionFailed = "SubmissionFailed",
  Failed = "Failed",
  Success = "Success",
  Pending = "Pending",
  PendingRerun = "PendingRerun",
  Failing = "Failing",
  Cancelling = "Cancelling",
  Cancelled = "Cancelled",
}

export enum UpdatableProjectField {
  PROJECT_UNSPECIFIED = "PROJECT_UNSPECIFIED",
  PROJECT_DESCRIPTION = "PROJECT_DESCRIPTION",
  PROJECT_CUSTOM_DATA = "PROJECT_CUSTOM_DATA",
  PROJECT_ACCESS_MODIFIER = "PROJECT_ACCESS_MODIFIER",
}

export enum UpdatableFeatureSetField {
  FEATURE_SET_UNSPECIFIED = "FEATURE_SET_UNSPECIFIED",
  FEATURE_SET_TAGS = "FEATURE_SET_TAGS",
  FEATURE_SET_DATA_SOURCE_DOMAINS = "FEATURE_SET_DATA_SOURCE_DOMAINS",
  FEATURE_SET_DESCRIPTION = "FEATURE_SET_DESCRIPTION",
  FEATURE_SET_TYPE = "FEATURE_SET_TYPE",
  FEATURE_SET_APPLICATION_NAME = "FEATURE_SET_APPLICATION_NAME",
  FEATURE_SET_APPLICATION_ID = "FEATURE_SET_APPLICATION_ID",
  FEATURE_SET_DEPRECATED = "FEATURE_SET_DEPRECATED",
  FEATURE_SET_PROCESS_INTERVAL = "FEATURE_SET_PROCESS_INTERVAL",
  FEATURE_SET_PROCESS_INTERVAL_UNIT = "FEATURE_SET_PROCESS_INTERVAL_UNIT",
  FEATURE_SET_FLOW = "FEATURE_SET_FLOW",
  FEATURE_SET_STATE = "FEATURE_SET_STATE",
  FEATURE_SET_TTL_OFFLINE = "FEATURE_SET_TTL_OFFLINE",
  FEATURE_SET_TTL_OFFLINE_INTERVAL = "FEATURE_SET_TTL_OFFLINE_INTERVAL",
  FEATURE_SET_TTL_ONLINE = "FEATURE_SET_TTL_ONLINE",
  FEATURE_SET_TTL_ONLINE_INTERVAL = "FEATURE_SET_TTL_ONLINE_INTERVAL",
  FEATURE_SET_CUSTOM_DATA = "FEATURE_SET_CUSTOM_DATA",
  FEATURE_SET_SPECIAL_DATA_LEGAL_APPROVED = "FEATURE_SET_SPECIAL_DATA_LEGAL_APPROVED",
  FEATURE_SET_SPECIAL_DATA_LEGAL_NOTES = "FEATURE_SET_SPECIAL_DATA_LEGAL_NOTES",
  FEATURE_SET_ONLINE_NAMESPACE = "FEATURE_SET_ONLINE_NAMESPACE",
  FEATURE_SET_ONLINE_TOPIC = "FEATURE_SET_ONLINE_TOPIC",
  FEATURE_SET_ONLINE_CONNECTION_TYPE = "FEATURE_SET_ONLINE_CONNECTION_TYPE",
}

export enum UpdatableFeatureField {
  FEATURE_UNSPECIFIED = "FEATURE_UNSPECIFIED",
  FEATURE_STATUS = "FEATURE_STATUS",
  FEATURE_TYPE = "FEATURE_TYPE",
  FEATURE_IMPORTANCE = "FEATURE_IMPORTANCE",
  FEATURE_CUSTOM_DATA = "FEATURE_CUSTOM_DATA",
  FEATURE_DESCRIPTION = "FEATURE_DESCRIPTION",
  FEATURE_SPECIAL = "FEATURE_SPECIAL",
  FEATURE_ANOMALY_DETECTION = "FEATURE_ANOMALY_DETECTION",
  FEATURE_CLASSIFIERS = "FEATURE_CLASSIFIERS",
}

export enum FeatureSetDraftType {
  FEATURE_SET_DRAFT_TYPE_UNSPECIFIED = "FEATURE_SET_DRAFT_TYPE_UNSPECIFIED",
  FEATURE_SET_DRAFT_TYPE_CREATE_NEW = "FEATURE_SET_DRAFT_TYPE_CREATE_NEW",
  FEATURE_SET_DRAFT_TYPE_CREATE_MAJOR_VERSION = "FEATURE_SET_DRAFT_TYPE_CREATE_MAJOR_VERSION",
  FEATURE_SET_DRAFT_TYPE_CREATE_NEW_DERIVED = "FEATURE_SET_DRAFT_TYPE_CREATE_NEW_DERIVED",
}

export enum ArtifactType {
  ARTIFACT_TYPE_UNSPECIFIED = "ARTIFACT_TYPE_UNSPECIFIED",
  ARTIFACT_TYPE_LINK = "ARTIFACT_TYPE_LINK",
  ARTIFACT_TYPE_FILE = "ARTIFACT_TYPE_FILE",
}

export enum ArtifactUploadStatus {
  ARTIFACT_UPLOAD_STATUS_NOT_APPLICABLE = "ARTIFACT_UPLOAD_STATUS_NOT_APPLICABLE",
  ARTIFACT_UPLOAD_STATUS_IN_PROGRESS = "ARTIFACT_UPLOAD_STATUS_IN_PROGRESS",
  ARTIFACT_UPLOAD_STATUS_DONE = "ARTIFACT_UPLOAD_STATUS_DONE",
  ARTIFACT_UPLOAD_STATUS_FAILED = "ARTIFACT_UPLOAD_STATUS_FAILED",
}

export enum ReviewStatus {
  REVIEW_STATUS_UNSPECIFIED = "REVIEW_STATUS_UNSPECIFIED",
  REVIEW_STATUS_TO_REVIEW = "REVIEW_STATUS_TO_REVIEW",
  REVIEW_STATUS_APPROVED = "REVIEW_STATUS_APPROVED",
  REVIEW_STATUS_REJECTED = "REVIEW_STATUS_REJECTED",
  REVIEW_STATUS_CREATED = "REVIEW_STATUS_CREATED",
}

export enum ProjectSearchRequestProjectSortField {
  PROJECT_SORT_FIELD_UNDEFINED = "PROJECT_SORT_FIELD_UNDEFINED",
  PROJECT_SORT_FIELD_NAME = "PROJECT_SORT_FIELD_NAME",
  PROJECT_SORT_FIELD_DESCRIPTION = "PROJECT_SORT_FIELD_DESCRIPTION",
  PROJECT_SORT_FIELD_ACCESS_MODIFIER = "PROJECT_SORT_FIELD_ACCESS_MODIFIER",
  PROJECT_SORT_FIELD_AUTHOR = "PROJECT_SORT_FIELD_AUTHOR",
  PROJECT_SORT_FIELD_LAST_UPDATE = "PROJECT_SORT_FIELD_LAST_UPDATE",
}

export enum AdminProjectSearchRequestProjectSortField {
  PROJECT_SORT_FIELD_UNDEFINED = "PROJECT_SORT_FIELD_UNDEFINED",
  PROJECT_SORT_FIELD_NAME = "PROJECT_SORT_FIELD_NAME",
  PROJECT_SORT_FIELD_DESCRIPTION = "PROJECT_SORT_FIELD_DESCRIPTION",
  PROJECT_SORT_FIELD_ACCESS_MODIFIER = "PROJECT_SORT_FIELD_ACCESS_MODIFIER",
  PROJECT_SORT_FIELD_AUTHOR = "PROJECT_SORT_FIELD_AUTHOR",
  PROJECT_SORT_FIELD_LAST_UPDATE = "PROJECT_SORT_FIELD_LAST_UPDATE",
}

export enum FeatureSetSearchRequestFeatureSetSortField {
  FEATURE_SET_SORT_FIELD_UNDEFINED = "FEATURE_SET_SORT_FIELD_UNDEFINED",
  FEATURE_SET_SORT_FIELD_NAME = "FEATURE_SET_SORT_FIELD_NAME",
  FEATURE_SET_SORT_FIELD_DESCRIPTION = "FEATURE_SET_SORT_FIELD_DESCRIPTION",
  FEATURE_SET_SORT_FIELD_AUTHOR = "FEATURE_SET_SORT_FIELD_AUTHOR",
  FEATURE_SET_SORT_FIELD_LAST_UPDATE = "FEATURE_SET_SORT_FIELD_LAST_UPDATE",
  FEATURE_SET_SORT_FIELD_PROJECT_NAME = "FEATURE_SET_SORT_FIELD_PROJECT_NAME",
}

export enum FeatureSearchRequestFeatureSortField {
  FEATURE_SORT_FIELD_UNDEFINED = "FEATURE_SORT_FIELD_UNDEFINED",
  FEATURE_SORT_FIELD_NAME = "FEATURE_SORT_FIELD_NAME",
  FEATURE_SORT_FIELD_DESCRIPTION = "FEATURE_SORT_FIELD_DESCRIPTION",
}

export enum ListableFeatureSetDraftFeatureSetDraftStatus {
  FEATURE_SET_DRAFT_STATUS_UNSPECIFIED = "FEATURE_SET_DRAFT_STATUS_UNSPECIFIED",
  FEATURE_SET_DRAFT_STATUS_IN_PROGRESS = "FEATURE_SET_DRAFT_STATUS_IN_PROGRESS",
  FEATURE_SET_DRAFT_STATUS_FINISHED = "FEATURE_SET_DRAFT_STATUS_FINISHED",
  FEATURE_SET_DRAFT_STATUS_FAILED = "FEATURE_SET_DRAFT_STATUS_FAILED",
}

export enum AdvancedSearchOptionSearchOperator {
  SEARCH_OPERATOR_UNSPECIFIED = "SEARCH_OPERATOR_UNSPECIFIED",
  SEARCH_OPERATOR_LIKE = "SEARCH_OPERATOR_LIKE",
  SEARCH_OPERATOR_EQ = "SEARCH_OPERATOR_EQ",
}

export enum AdvancedSearchOptionSearchField {
  SEARCH_FIELD_UNSPECIFIED = "SEARCH_FIELD_UNSPECIFIED",
  SEARCH_FIELD_FEATURE_NAME = "SEARCH_FIELD_FEATURE_NAME",
  SEARCH_FIELD_FEATURE_DESCRIPTION = "SEARCH_FIELD_FEATURE_DESCRIPTION",
  SEARCH_FIELD_FEATURE_TAG = "SEARCH_FIELD_FEATURE_TAG",
}

export type ListRecentGptCollectionsRequest = {
  offset?: number
  limit?: number
}

export type GptCollection = {
  id?: string
  name?: string
  description?: string
  documentCount?: number
  documentSize?: string
  updatedAt?: GoogleProtobufTimestamp.Timestamp
  userCount?: number
  isPublic?: boolean
  username?: string
  sessionsCount?: number
}

export type ListRecentGptCollectionsResponse = {
  collections?: GptCollection[]
}

export type CreateGptChatSessionRequest = {
  collectionId?: string
}

export type CreateGptChatSessionResponse = {
  sessionId?: string
}

export type ValidatePersonalTokenResponse = {
  user?: UserBasicInfo
  authorities?: string[]
  expireAt?: GoogleProtobufTimestamp.Timestamp
}

export type GetUserPermissionsRequest = {
  resourceId?: string
  permissionFilter?: PermissionType
  pageSize?: number
  pageToken?: string
}

export type GetUserActivePermissionsRequest = {
  resourceId?: string
  permissionFilters?: PermissionType[]
  query?: string
  pageSize?: number
  pageToken?: string
}

export type GetUserPermissionsResponse = {
  users?: UserWithPermission[]
  nextPageToken?: string
}

export type UserWithPermission = {
  user?: UserBasicInfo
  resourcePermission?: ResourcePermission
}

export type ResourcePermission = {
  permission?: PermissionType
  resourceType?: ResourceType
}

export type GetUsersWithoutPermissionRequest = {
  resourceId?: string
  pageSize?: number
  pageToken?: string
}

export type GetUsersWithoutPermissionResponse = {
  users?: UserBasicInfo[]
  nextPageToken?: string
}

export type ListPersonalAccessTokensRequest = {
  pageSize?: number
  pageToken?: string
  query?: string
}

export type ListPersonalAccessTokensResponse = {
  personalAccessTokens?: PersonalAccessToken[]
  nextPageToken?: string
}

export type IdentityProviderDetails = {
  idpMetaUrl?: string
  clientId?: string
  scopes?: string[]
}

export type GetWebConfigResponse = {
  ipdDetails?: IdentityProviderDetails
  appStoreUrl?: string
  webUrl?: string
  reviewRoles?: string[]
  gpteUrl?: string
  localDataSourcesEnabled?: boolean
  uiDataDownloadEnabled?: boolean
}

export type GetFeatureSetsLastMinorForCurrentMajorRequest = {
  featureSetId?: string
  featureSetVersion?: string
}

export type GetLastMinorFeatureSetForMajorInProjectRequest = {
  projectId?: string
  featureSetName?: string
  featureSetMajorVersion?: number
}

export type FeatureSetExistsRequest = {
  featureSetId?: string
  excludeDeleted?: boolean
  featureSetMajorVersion?: number
}

export type GetIngestHistoryRequest = {
  featureSetId?: string
  featureSetVersion?: string
}

export type ProjectExistsRequest = {
  projectId?: string
  excludeDeleted?: boolean
}

export type ExistsResponse = {
  exists?: boolean
}

export type HasPermissionToRetrieveRequest = {
  projectName?: string
  featureSetName?: string
}

export type HasPermissionToRetrieveResponse = {
  hasRetrievePermission?: boolean
}

export type StartRevertIngestJobRequest = {
  ingestId?: string
  featureSetId?: string
  featureSetVersion?: string
}

export type OnlineRetrieveMeta = {
  baseOnlineUrl?: string
  username?: string
  password?: string
  isEnabled?: boolean
}

export type RefreshTokenRequest = {
  refreshToken?: string
}

export type TokenRequest = {
  tokenId?: string
}

export type GenerateTokenRequest = {
  name?: string
  description?: string
  expiryDate?: GoogleProtobufTimestamp.Timestamp
}

export type TokenResponse = {
  token?: PersonalAccessToken
}

export type RawTokenResponse = {
  token?: string
  tokenExpiryDate?: GoogleProtobufTimestamp.Timestamp
}

export type TokensConfigResponse = {
  maximumAllowedTokenDuration?: GoogleProtobufDuration.Duration
}

export type ListJobsRequest = {
  active?: boolean
  jobType?: JobType
  featureSetId?: string
}

export type ListJobsResponse = {
  jobs?: Job[]
}

export type FeatureSetSchemaCompatibilityRequest = {
  originalSchema?: FeatureSchema[]
  newSchema?: FeatureSchema[]
  compareDataTypes?: boolean
}

export type FeatureSetSchemaCompatibilityResponse = {
  isCompatible?: boolean
}

export type FeatureSetSchemaPatchRequest = {
  originalSchema?: FeatureSchema[]
  newSchema?: FeatureSchema[]
  compareDataTypes?: boolean
}

export type FeatureSetSchemaPatchResponse = {
  schema?: FeatureSchema[]
}

export type JobId = {
  jobId?: string
}

export type GetRecommendationRequest = {
  featureSetId?: string
}

export type GetRecommendationResponseJoin = {
  classifier?: string
  columns?: string[]
}

export type GetRecommendationResponseMatch = {
  targetFeatureSet?: FeatureSet
  joins?: GetRecommendationResponseJoin[]
}

export type GetRecommendationResponse = {
  matches?: GetRecommendationResponseMatch[]
}

export type Job = {
  jobId?: string
  jobType?: JobType
  done?: boolean
  childJobIds?: string[]
  cancelled?: boolean
  jobStatus?: JobStatus
  createdBy?: UserBasicInfo
  createdOn?: GoogleProtobufTimestamp.Timestamp
  errorMessage?: string
}

export type JobProgressInput = {
  jobId?: string
  nextIndex?: number
}

export type JobProgressOutputProgress = {
  message?: string
  durationInSeconds?: number
  timestamp?: GoogleProtobufTimestamp.Timestamp
}

export type JobProgressOutput = {
  progress?: JobProgressOutputProgress[]
}

export type FeatureSetPermissionRequest = {
  userEmails?: string[]
  permission?: PermissionType
  featureSetId?: string
}

export type ProjectPermissionRequest = {
  userEmails?: string[]
  permission?: PermissionType
  projectId?: string
}


type BaseStartExtractSchemaJobRequest = {
  cred?: Credentials
}

export type StartExtractSchemaJobRequest = BaseStartExtractSchemaJobRequest
  & OneOf<{ rawData: RawDataLocation; derivedFrom: DerivedInformation }>

export type ExtractSchemaResponse = {
  schema?: FeatureSchema[]
  derivedFrom?: DerivedInformation
}

export type ListFeatureSetsVersionRequest = {
  featureSetId?: string
}

export type FeatureSetResponse = {
  featureSet?: FeatureSet
  job?: JobId
}

export type UpdateFeatureSetResponse = {
  updatedFeatureSet?: FeatureSet
}

export type UpdateProjectResponse = {
  updatedProject?: Project
}

export type UpdateFeatureResponse = {
  updatedFeatureSet?: FeatureSet
  updatedFeature?: Feature
}

export type ProjectResponse = {
  project?: Project
}


type BaseLoginResponse = {
}

export type LoginResponse = BaseLoginResponse
  & OneOf<{ loginUrl: string; refreshToken: string }>

export type GetActiveUserResponse = {
  user?: UserBasicInfo
  userRoles?: string[]
}

export type GetProjectRequest = {
  projectName?: string
}

export type GetProjectByIdRequest = {
  projectId?: string
}

export type DeleteFeatureSetRequest = {
  featureSetId?: string
}

export type DeleteFeatureSetVersionRequest = {
  featureSetId?: string
  featureSetMajorVersion?: number
}

export type LogoutRequest = {
  refreshToken?: string
}

export type UserBasicInfo = {
  id?: string
  name?: string
  email?: string
  preferredName?: string
}

export type User = {
  userBasicInfo?: UserBasicInfo
  admin?: boolean
}

export type AccessTokenResponse = {
  accessToken?: string
  refreshToken?: string
  expiresIn?: string
  scope?: string
  tokenType?: string
}

export type DeleteProjectRequest = {
  projectId?: string
}

export type CreateProjectRequest = {
  projectName?: string
  description?: string
  customData?: GoogleProtobufStruct.Struct
  accessModifier?: AccessModifier
}

export type CreateProjectResponse = {
  project?: Project
  alreadyExists?: boolean
}

export type ListProjectsResponse = {
  projects?: Project[]
}

export type ListProjectHistoryPageRequest = {
  projectId?: string
  pageSize?: number
  pageToken?: string
}

export type ProjectHistory = {
  action?: ProjectAction
  performedBy?: UserBasicInfo
  project?: Project
}

export type ListProjectHistoryPageResponse = {
  history?: ProjectHistory[]
  nextPageToken?: string
}

export type GetIngestHistoryResponse = {
  ingestHistory?: FeatureSetIngest[]
}

export type ListFeatureSetsPageRequest = {
  projectNames?: string[]
  pageSize?: number
  pageToken?: string
}

export type ListFeatureSetsPageResponse = {
  featureSets?: FeatureSet[]
  nextPageToken?: string
}

export type AWSCredentials = {
  accessToken?: string
  secretToken?: string
  region?: string
  endpoint?: string
  roleArn?: string
  sessionToken?: string
}

export type AzureCredentials = {
  accountName?: string
  accountKey?: string
  sasToken?: string
  sasContainer?: string
  spClientId?: string
  spTenantId?: string
  spSecret?: string
}

export type SnowflakeCredentials = {
  user?: string
  password?: string
  pemPrivateKey?: string
  passphrase?: string
}

export type JDBCCredentials = {
  user?: string
  password?: string
}

export type MongoDbCredentials = {
  user?: string
  password?: string
}

export type DriveCredentials = {
}

export type GcpCredentials = {
  credentialsFileContent?: string
}

export type Credentials = {
  aws?: AWSCredentials
  azure?: AzureCredentials
  snowflake?: SnowflakeCredentials
  jdbcDatabase?: JDBCCredentials
  mongoDb?: MongoDbCredentials
  drive?: DriveCredentials
  gcp?: GcpCredentials
}

export type ListFeatureSetsResponse = {
  featureSets?: FeatureSet[]
}

export type ListFeatureSetVersionsResponse = {
  versions?: FeatureSetVersionDescription[]
}

export type FeatureSetVersionDescription = {
  version?: string
  versionChange?: string
  createdDateTime?: GoogleProtobufTimestamp.Timestamp
}

export type GetFeatureSetRequest = {
  featureSetName?: string
  version?: string
  projectId?: string
}

export type StartIngestJobRequest = {
  cred?: Credentials
  dataSource?: RawDataLocation
  featureSetId?: string
  featureSetVersion?: string
}

export type IngestResponseIngestMeta = {
  cacheLocation?: string
  rawCacheLocation?: string
  ingestionTimestamp?: GoogleProtobufTimestamp.Timestamp
  ingestScope?: Scope
  message?: string
  ingestId?: string
}

export type IngestResponse = {
  meta?: IngestResponseIngestMeta
  featureSetId?: string
  featureSetVersion?: string
}

export type RetrieveRequest = {
  startDateTime?: string
  endDateTime?: string
  ingestId?: string
  sessionId?: string
  featureSetId?: string
  featureSetVersion?: string
}

export type RetrieveAsLinksResponse = {
  downloadLinks?: string[]
  retrieveScope?: Scope
  retrieveJobExecuted?: boolean
}

export type RetrieveAsSparkResponse = {
  cachePath?: string
  options?: {[key: string]: string}
  retrieveScope?: Scope
  sessionId?: string
  deltaVersion?: string
  offlineStorageFormat?: OfflineStorageFormat
}

export type StartMaterializationOnlineRequest = {
  featureSetId?: string
  featureSetVersion?: string
}

export type MaterializationOnlineResponse = {
  materializationScope?: Scope
  numRecords?: string
}

export type StartOnlineOfflineIngestionRequest = {
  featureSetId?: string
  featureSetVersion?: string
}

export type StartOptimizeStorageJobRequest = {
  featureSetId?: string
  featureSetVersion?: string
  optimization?: StorageOptimization
}


type BaseStorageOptimization = {
}

export type StorageOptimization = BaseStorageOptimization
  & OneOf<{ zOrderBy: OptimizeStorageZOrderBySpec; compact: OptimizeStorageCompactSpec }>

export type OptimizeStorageZOrderBySpec = {
  columns?: string[]
}

export type OptimizeStorageCompactSpec = {
}

export type OptimizeStorageResponse = {
  optimizationMetrics?: string
}


type BaseRawDataLocation = {
}

export type RawDataLocation = BaseRawDataLocation
  & OneOf<{ csv: CSVFileSpec; parquet: ParquetFileSpec; snowflake: SnowflakeTableSpec; jdbc: JDBCTableSpec; json: JSONFileSpec; deltaTable: DeltaTableSpec; csvFolder: CSVFolderSpec; parquetFolder: ParquetFolderSpec; jsonFolder: JSONFolderSpec; onlineSource: OnlineSourceSpec; mongoDb: MongoDbCollectionSpec; googleBigQuery: BigQueryTableSpec }>

export type OnlineSourceSpec = {
  absoluteJsonFolderPath?: string
}

export type CSVFileSpec = {
  path?: string
  delimiter?: string
}

export type JSONFileSpec = {
  path?: string
  multiline?: boolean
}

export type ParquetFileSpec = {
  path?: string
}

export type Proxy = {
  host?: string
  port?: number
  user?: string
  password?: string
}

export type SnowflakeTableSpec = {
  table?: string
  database?: string
  url?: string
  query?: string
  warehouse?: string
  schema?: string
  insecure?: boolean
  proxy?: Proxy
  role?: string
  account?: string
}

export type JDBCTableSpec = {
  table?: string
  query?: string
  connectionUrl?: string
  numPartitions?: number
  partitionColumn?: string
  lowerBound?: string
  upperBound?: string
  fetchSize?: number
}

export type DeltaTableSpec = {
  path?: string
  version?: number
  timestamp?: string
  filter?: AiH2oFeaturestoreApiV1FeatureSetSearch.Filter
}

export type CSVFolderSpec = {
  rootFolder?: string
  filterPattern?: string
  delimiter?: string
}

export type ParquetFolderSpec = {
  rootFolder?: string
  filterPattern?: string
}

export type JSONFolderSpec = {
  rootFolder?: string
  filterPattern?: string
  multiline?: boolean
}

export type MongoDbCollectionSpec = {
  connectionUri?: string
  database?: string
  collection?: string
}

export type BigQueryTableSpec = {
  table?: string
  parentProject?: string
  query?: string
  materializationDataset?: string
}

export type MojoTransformation = {
  filename?: string
}

export type SparkPipelineTransformation = {
  filename?: string
}

export type JoinTransformation = {
  leftKey?: string
  rightKey?: string
  joinType?: JoinType
}

export type VersionedId = {
  id?: string
  majorVersion?: number
}


type BaseTransformation = {
}

export type Transformation = BaseTransformation
  & OneOf<{ mojo: MojoTransformation; sparkPipeline: SparkPipelineTransformation; join: JoinTransformation }>

export type DerivedInformation = {
  featureSetIds?: VersionedId[]
  transformation?: Transformation
}

export type SelectedFeature = {
  prefix?: string
  feature?: string
  transformation?: string
}


type BaseFilterConditionUnion = {
}

export type FilterConditionUnion = BaseFilterConditionUnion
  & OneOf<{ filter: FeatureFilter; logic: FeatureFilterLogic }>

export type FeatureFilter = {
  feature?: SelectedFeature
  operator?: FeatureFilterOperator
  value?: string
}

export type FeatureFilterLogic = {
  left?: FilterConditionUnion
  right?: FilterConditionUnion
  logicOperator?: FeatureFilterLogicOperator
}

export type FeatureSetStatistics = {
  dataLatency?: number
  recordsCount?: string
}

export type FeatureSetSpecialDataLegal = {
  approved?: boolean
  approvedDate?: GoogleProtobufTimestamp.Timestamp
  notes?: string
}

export type FeatureSetSpecialData = {
  spi?: boolean
  pci?: boolean
  rpi?: boolean
  demographic?: boolean
  sensitive?: boolean
  legal?: FeatureSetSpecialDataLegal
}

export type FeatureSetOnline = {
  onlineNamespace?: string
  connectionType?: string
  topic?: string
}

export type FeatureSet = {
  project?: string
  featureSetName?: string
  version?: string
  versionChange?: string
  timeTravelColumn?: string
  timeTravelColumnFormat?: string
  featureSetType?: AiH2oFeaturestoreApiV1FeatureSetProtoApi.FeatureSetType
  description?: string
  author?: UserBasicInfo
  createdDateTime?: GoogleProtobufTimestamp.Timestamp
  lastUpdateDateTime?: GoogleProtobufTimestamp.Timestamp
  applicationName?: string
  deprecated?: boolean
  deprecatedDate?: GoogleProtobufTimestamp.Timestamp
  dataSourceDomains?: string[]
  tags?: string[]
  processInterval?: number
  processIntervalUnit?: ProcessIntervalUnit
  flow?: string
  timeToLive?: AiH2oFeaturestoreApiV1TimeToLiveApi.TimeToLive
  features?: Feature[]
  statistics?: FeatureSetStatistics
  specialData?: FeatureSetSpecialData
  primaryKey?: string[]
  id?: string
  timeTravelScope?: Scope
  applicationId?: string
  featureSetState?: string
  online?: FeatureSetOnline
  projectId?: string
  partitionBy?: string[]
  customData?: GoogleProtobufStruct.Struct
  onlineMaterializationScope?: Scope
  derivedFrom?: DerivedInformation
  featureClassifiers?: string[]
  lastUpdatedBy?: UserBasicInfo
  storageOptimization?: StorageOptimization
}

export type GetFeatureSetPreviewRequest = {
  featureSetId?: string
  featureSetVersion?: string
}

export type GetFeatureSetPreviewResponse = {
  previewUrl?: string
  maxColsNum?: number
}

export type Scope = {
  startDateTime?: GoogleProtobufTimestamp.Timestamp
  endDateTime?: GoogleProtobufTimestamp.Timestamp
}

export type RegisterFeatureSetRequest = {
  featureSetName?: string
  project?: Project
  timeTravelColumn?: string
  timeTravelColumnFormat?: string
  primaryKey?: string[]
  schema?: FeatureSchema[]
  description?: string
  partitionBy?: string[]
  timeTravelColumnAsPartition?: boolean
  featureSetType?: AiH2oFeaturestoreApiV1FeatureSetProtoApi.FeatureSetType
  featureSetState?: string
  applicationName?: string
  applicationId?: string
  online?: FeatureSetOnline
  dataSourceDomains?: string[]
  tags?: string[]
  processInterval?: number
  processIntervalUnit?: ProcessIntervalUnit
  flow?: string
  specialData?: FeatureSetSpecialData
  customData?: GoogleProtobufStruct.Struct
  timeToLive?: AiH2oFeaturestoreApiV1TimeToLiveApi.TimeToLive
  derivedFrom?: DerivedInformation
}

export type CreateNewFeatureSetVersionRequest = {
  schema?: FeatureSchema[]
  affectedFeatures?: string[]
  reason?: string
  derivedFrom?: DerivedInformation
  primaryKey?: string[]
  usePrimaryKeyFromPreviousVersion?: boolean
  backfillOptions?: BackfillOptions
  partitionBy?: string[]
  usePartitionByFromPreviousVersion?: boolean
  useTimeTravelColumnAsPartition?: boolean
  featureSetId?: string
  featureSetVersion?: string
  timeTravelColumn?: string
  timeTravelColumnFormat?: string
  useTimeTravelColumnFromPreviousVersion?: boolean
  useTimeTravelColumnFormatFromPreviousVersion?: boolean
}

export type FeatureProfile = {
  featureType?: AiH2oFeaturestoreApiV1FeatureSetProtoApi.FeatureType
  categorical?: CategoricalFeatureStatistics
  statistics?: FeatureStatistics
  statisticsAvailable?: boolean
}

export type FeatureSchemaSpecialData = {
  spi?: boolean
  pci?: boolean
  rpi?: boolean
  demographic?: boolean
  sensitive?: boolean
}

export type FeatureSchemaMonitoring = {
  anomalyDetection?: boolean
}

export type FeatureSchema = {
  name?: string
  dataType?: string
  nested?: FeatureSchema[]
  specialData?: FeatureSchemaSpecialData
  featureType?: AiH2oFeaturestoreApiV1FeatureSetProtoApi.FeatureType
  description?: string
  classifiers?: string[]
  customData?: GoogleProtobufStruct.Struct
  monitoring?: FeatureSchemaMonitoring
}

export type FeatureMonitoring = {
  anomalyDetection?: boolean
}

export type FeatureSpecialData = {
  spi?: boolean
  pci?: boolean
  rpi?: boolean
  demographic?: boolean
  sensitive?: boolean
}

export type Feature = {
  name?: string
  version?: string
  versionChange?: string
  status?: string
  dataType?: string
  profile?: FeatureProfile
  description?: string
  importance?: number
  special?: string
  monitoring?: FeatureMonitoring
  nestedFeatures?: Feature[]
  specialData?: FeatureSpecialData
  classifiers?: string[]
  customData?: GoogleProtobufStruct.Struct
  id?: string
  featureSetId?: string
}

export type FeatureStatistics = {
  max?: number
  mean?: number
  median?: number
  min?: number
  stddev?: number
  stddevRecCount?: string
  nullCount?: string
  nanCount?: string
  unique?: string
}

export type CategoricalFeatureStatisticsFeatureTop = {
  name?: string
  count?: string
}

export type CategoricalFeatureStatistics = {
  unique?: string
  top?: CategoricalFeatureStatisticsFeatureTop[]
}

export type GetVersionResponse = {
  version?: string
}

export type GetApiConfigResponse = {
  publicCoreRestApiUrl?: string
  publicOnlineRestApiUrl?: string
}

export type GetGpteConfigResponse = {
  apiKey?: string
}

export type Project = {
  name?: string
  description?: string
  author?: UserBasicInfo
  createdDateTime?: GoogleProtobufTimestamp.Timestamp
  lastUpdateDateTime?: GoogleProtobufTimestamp.Timestamp
  id?: string
  customData?: GoogleProtobufStruct.Struct
  featureSetsCount?: string
  lastUpdatedBy?: UserBasicInfo
  accessModifier?: AccessModifier
}

export type ListableProject = {
  id?: string
  name?: string
  description?: string
  lastUpdateDateTime?: GoogleProtobufTimestamp.Timestamp
  permission?: ActivePermission
  author?: UserBasicInfo
  featureSetsCount?: string
  accessModifier?: AccessModifier
}

export type FeatureSetIngest = {
  ingestId?: string
  ingestTimestamp?: GoogleProtobufTimestamp.Timestamp
  source?: RawDataLocation
  featureSetId?: string
  featureSetVersion?: string
  scope?: Scope
  parentIngests?: string[]
  ingestedRecordsCount?: string
  startedBy?: UserBasicInfo
}

export type PersonalAccessToken = {
  id?: string
  name?: string
  description?: string
  lastUsed?: GoogleProtobufTimestamp.Timestamp
  creationTime?: GoogleProtobufTimestamp.Timestamp
  expiryDate?: GoogleProtobufTimestamp.Timestamp
}

export type GenerateTransformationUploadRequest = {
  transformationType?: TransformationType
  md5Checksum?: string
}

export type GenerateTransformationUploadResponse = {
  filename?: string
  url?: string
  headers?: {[key: string]: string}
}

export type GenerateTemporaryUploadRequest = {
  filesWithMd5Checksum?: {[key: string]: string}
}

export type GenerateTemporaryUploadFileResponse = {
  presignUrl?: string
  headers?: {[key: string]: string}
  url?: string
}

export type GenerateTemporaryUploadResponse = {
  fileResponses?: {[key: string]: GenerateTemporaryUploadFileResponse}
  directoryUrl?: string
}

export type ListProjectsPageRequest = {
  pageSize?: number
  pageToken?: string
}

export type ListProjectsPageResponse = {
  projects?: Project[]
  nextPageToken?: string
}

export type ProjectSearchRequest = {
  query?: string
  pageSize?: number
  pageToken?: string
  requiredPermission?: ActivePermission
  projectIds?: string[]
  sortField?: ProjectSearchRequestProjectSortField
  sortDirection?: SortDirection
}

export type AdminProjectSearchRequest = {
  query?: string
  pageSize?: number
  pageToken?: string
  requiredPermission?: ActivePermission
  projectIds?: string[]
  sortField?: AdminProjectSearchRequestProjectSortField
  sortDirection?: SortDirection
  userEmail?: string
}

export type FeatureSetSearchRequest = {
  query?: string
  pageSize?: number
  pageToken?: string
  ownedOnly?: boolean
  projectIds?: string[]
  sortField?: FeatureSetSearchRequestFeatureSetSortField
  sortDirection?: SortDirection
  options?: AdvancedSearchOption[]
}

export type FeatureSearchRequest = {
  query?: string
  pageSize?: number
  pageToken?: string
  ownedOnly?: boolean
  projectIds?: string[]
  sortField?: FeatureSearchRequestFeatureSortField
  sortDirection?: SortDirection
}

export type ProjectSearchResults = {
  listableProject?: ListableProject[]
  nextPageToken?: string
}

export type ListableFeatureSet = {
  id?: string
  name?: string
  description?: string
  projectName?: string
  lastUpdateDateTime?: GoogleProtobufTimestamp.Timestamp
  version?: string
  permission?: ActivePermission
  projectId?: string
  versionChange?: string
  timeTravelColumn?: string
  timeTravelColumnFormat?: string
  featureSetType?: AiH2oFeaturestoreApiV1FeatureSetProtoApi.FeatureSetType
  author?: UserBasicInfo
  createdDateTime?: GoogleProtobufTimestamp.Timestamp
  deprecated?: boolean
  deprecatedDate?: GoogleProtobufTimestamp.Timestamp
  tags?: string[]
  timeToLive?: AiH2oFeaturestoreApiV1TimeToLiveApi.TimeToLive
  specialData?: FeatureSetSpecialData
  primaryKey?: string[]
  timeTravelScope?: Scope
  partitionBy?: string[]
  onlineMaterializationScope?: Scope
  derivedFrom?: DerivedInformation
  featureClassifiers?: string[]
  recordsCount?: string
  flow?: AiH2oFeaturestoreApiV1FeatureSetProtoApi.FeatureSetFlow
  applicationName?: string
  dataSourceDomains?: string[]
  processInterval?: number
  processIntervalUnit?: ProcessIntervalUnit
  statistics?: FeatureSetStatistics
  applicationId?: string
  featureSetState?: string
  online?: FeatureSetOnline
  customData?: GoogleProtobufStruct.Struct
  lastUpdatedBy?: UserBasicInfo
  storageOptimization?: StorageOptimization
}

export type FeatureSetSearchResults = {
  listableFeatureSet?: ListableFeatureSet[]
  nextPageToken?: string
}

export type ListableFeature = {
  featureSetId?: string
  name?: string
  description?: string
  anomalyDetection?: boolean
  featureType?: AiH2oFeaturestoreApiV1FeatureSetProtoApi.FeatureType
  dataType?: string
  version?: string
  featureId?: string
}

export type FeatureSearchResults = {
  listableFeature?: ListableFeature[]
  nextPageToken?: string
}

export type FeatureSetRequestId = {
  featureSetId?: string
  featureSetVersion?: string
}

export type GetFeatureRequest = {
  featureSetId?: string
  featureSetVersion?: string
  featureId?: string
}

export type ListFeaturesPageResponse = {
  features?: Feature[]
  nextPageToken?: string
}

export type FeatureResponse = {
  feature?: Feature
}

export type ListFeaturesRequest = {
  featureSetId?: string
  pageSize?: number
  pageToken?: string
  query?: string
  featureSetVersion?: string
}

export type ListFeaturesResponse = {
  features?: Feature[]
  nextPageToken?: string
}

export type ListableFeatureSetRequest = {
  featureSetId?: string
  featureSetVersion?: string
}

export type ListableFeatureSetResponse = {
  listableFeatureSet?: ListableFeatureSet
}

export type FeatureSetsDerivedFromRequest = {
  featureSetId?: string
  featureSetMajorVersion?: string
}

export type FeatureSetsDerivedFromResponse = {
  listableFeatureSets?: ListableFeatureSet[]
}

export type SubmitPendingPermissionRequest = {
  resourceId?: string
  permission?: PermissionType
  reason?: string
}

export type SubmitPendingPermissionResponse = {
  permissionId?: string
}

export type ListPermissionsPageRequest = {
  filters?: PermissionState[]
  pageSize?: number
  pageToken?: string
  resourceId?: string
}

export type ListProjectsPermissionsPageResponse = {
  entries?: ListableProjectToPermission[]
  nextPageToken?: string
}

export type ListFeatureSetsPermissionsPageResponse = {
  entries?: ListableFeatureSetToPermission[]
  nextPageToken?: string
}

export type ListableProjectToPermission = {
  project?: ListableProject
  permission?: Permission
}

export type ListableFeatureSetToPermission = {
  featureSet?: ListableFeatureSet
  permission?: Permission
}

export type PermissionPromotedUpdate = {
  user?: UserBasicInfo
  updatedOn?: GoogleProtobufTimestamp.Timestamp
  reason?: string
  replacedByPermissionId?: string
}

export type PermissionRevokedUpdate = {
  user?: UserBasicInfo
  updatedOn?: GoogleProtobufTimestamp.Timestamp
  reason?: string
}

export type PermissionGrantedOrRejectedUpdate = {
  user?: UserBasicInfo
  updatedOn?: GoogleProtobufTimestamp.Timestamp
  reason?: string
}

export type Permission = {
  id?: string
  resourceId?: string
  resourceType?: ResourceType
  permission?: PermissionType
  user?: UserBasicInfo
  creationReason?: string
  state?: PermissionState
  createdOn?: GoogleProtobufTimestamp.Timestamp
  lastUpdateOn?: GoogleProtobufTimestamp.Timestamp
  active?: boolean
  grantedOrRejected?: PermissionGrantedOrRejectedUpdate
  revoked?: PermissionRevokedUpdate
  promoted?: PermissionPromotedUpdate
}

export type RevokePermissionRequest = {
  permissionId?: string
  reason?: string
}

export type ApprovePendingPermissionRequest = {
  permissionId?: string
  reason?: string
}

export type RejectPendingPermissionRequest = {
  permissionId?: string
  reason?: string
}

export type WithdrawPendingPermissionRequest = {
  permissionId?: string
}

export type GetActivePermissionRequest = {
  resourceId?: string
}

export type GetActivePermissionResponse = {
  permission?: ActivePermission
  resourceType?: ResourceType
}

export type ScheduledTask = {
  id?: string
  name?: string
  description?: string
  featureSetId?: string
  projectId?: string
  source?: RawDataLocation
  schedule?: string
  nextRunTime?: GoogleProtobufTimestamp.Timestamp
  lastExec?: GoogleProtobufTimestamp.Timestamp
  owner?: UserBasicInfo
  createdDateTime?: GoogleProtobufTimestamp.Timestamp
  lastUpdateDateTime?: GoogleProtobufTimestamp.Timestamp
  taskType?: TaskType
  featureSetVersion?: string
  cronTimeZone?: string
  allowedFailures?: number
}

export type ScheduleTaskRequest = {
  featureSetId?: string
  name?: string
  description?: string
  projectId?: string
  cred?: Credentials
  source?: RawDataLocation
  schedule?: string
  featureSetVersion?: string
  cronTimeZone?: string
  allowedFailures?: number
}

export type ListScheduledTasksRequest = {
  featureSetId?: string
  pageSize?: number
  pageToken?: string
}

export type ListScheduledTasksResponse = {
  tasks?: ScheduledTask[]
  nextPageToken?: string
}

export type ScheduledTaskId = {
  scheduledTaskId?: string
}

export type ScheduledTaskResponse = {
  task?: ScheduledTask
}

export type ScheduledTaskUpdateRequest = {
  scheduledTaskId?: string
  description?: string
  schedule?: string
  updatedFields?: string[]
}

export type PauseScheduledTaskRequest = {
  scheduledTaskId?: string
}

export type ResumeScheduledTaskRequest = {
  scheduledTaskId?: string
  setupFailures?: boolean
  allowedFailures?: number
}

export type LazyIngestRequest = {
  featureSetId?: string
  featureSetVersion?: string
}

export type LazyIngestResponse = {
  jobId?: JobId
}

export type GetLazyIngestTaskRequest = {
  featureSetId?: string
  featureSetVersion?: string
}

export type ListScheduledTaskExecutionsRequest = {
  scheduledTaskId?: string
  pageSize?: number
  pageToken?: string
}

export type ScheduledTaskExecution = {
  jobId?: JobId
  startedAt?: GoogleProtobufTimestamp.Timestamp
  finishedAt?: GoogleProtobufTimestamp.Timestamp
  finalStatus?: JobStatus
}

export type ListScheduledTaskExecutionsResponse = {
  executionHistory?: ScheduledTaskExecution[]
  nextPageToken?: string
}

export type UpdateProjectRequest = {
  projectId?: string
  description?: string
  customData?: GoogleProtobufStruct.Struct
  fieldsToUpdate?: UpdatableProjectField[]
  accessModifier?: AccessModifier
}

export type UpdateFeatureSetRequest = {
  featureSetId?: string
  featureSetVersion?: string
  tags?: string[]
  dataSourceDomains?: string[]
  description?: string
  type?: AiH2oFeaturestoreApiV1FeatureSetProtoApi.FeatureSetType
  deprecated?: boolean
  processInterval?: number
  processIntervalUnit?: ProcessIntervalUnit
  timeToLiveOfflineInterval?: number
  timeToLiveOfflineIntervalUnit?: AiH2oFeaturestoreApiV1TimeToLiveApi.OfflineTimeToLiveInterval
  timeToLiveOnlineInterval?: number
  timeToLiveOnlineIntervalUnit?: AiH2oFeaturestoreApiV1TimeToLiveApi.OnlineTimeToLiveInterval
  legalApproved?: boolean
  legalApprovedNotes?: string
  state?: string
  flow?: string
  applicationName?: string
  applicationId?: string
  customData?: GoogleProtobufStruct.Struct
  onlineNamespace?: string
  onlineTopic?: string
  onlineConnectionType?: string
  fieldsToUpdate?: UpdatableFeatureSetField[]
}

export type UpdateFeatureRequest = {
  featureSetId?: string
  featureSetVersion?: string
  featureId?: string
  status?: string
  type?: AiH2oFeaturestoreApiV1FeatureSetProtoApi.FeatureType
  importance?: number
  customData?: GoogleProtobufStruct.Struct
  description?: string
  special?: string
  anomalyDetection?: boolean
  classifiers?: string[]
  fieldsToUpdate?: UpdatableFeatureField[]
}

export type BackfillOptions = {
  fromDate?: GoogleProtobufTimestamp.Timestamp
  toDate?: GoogleProtobufTimestamp.Timestamp
  fromVersion?: string
  sparkPipeline?: SparkPipelineTransformation
  featureMapping?: {[key: string]: string}
}

export type BackfillResponse = {
  ingestResponse?: IngestResponse
}

export type FeatureSetDraftRequest = {
  projectId?: string
  name?: string
  description?: string
  tags?: string[]
  cred?: Credentials
  dataSource?: RawDataLocation
  derivedFrom?: DerivedInformation
}

export type FeatureSetMajorVersionDraftRequest = {
  projectId?: string
  name?: string
  featureSetId?: string
  featureSetVersion?: string
  reason?: string
  cred?: Credentials
  dataSource?: RawDataLocation
}

export type DraftToFeatureSetRequestTimeTravelColumn = {
  timeTravelColumnName?: string
  timeTravelColumnFormat?: string
  isPartitionColumn?: boolean
}

export type DraftToFeatureSetRequest = {
  id?: string
  projectId?: string
  name?: string
  description?: string
  schema?: FeatureSchemaDraft[]
  timeTravelColumn?: DraftToFeatureSetRequestTimeTravelColumn
  tags?: string[]
}

export type MajorVersionDraftToFeatureSetVersionRequest = {
  id?: string
  projectId?: string
  schema?: FeatureSchemaDraft[]
  reason?: string
  backfillOptions?: BackfillOptions
  useTimeTravelColumnAsPartition?: boolean
  featureSetId?: string
  featureSetVersion?: string
  newTimeTravelColumn?: string
  newTimeTravelColumnFormat?: string
}

export type DraftToFeatureSetResponse = {
  featureSetId?: string
}

export type MajorVersionDraftToFeatureSetVersionResponse = {
  featureSetId?: string
  jobId?: string
  featureSetVersion?: string
  featureSetName?: string
}

export type FeatureSchemaDraftSpecialData = {
  spi?: boolean
  pci?: boolean
  rpi?: boolean
  demographic?: boolean
  sensitive?: boolean
}

export type FeatureSchemaDraft = {
  name?: string
  dataType?: string
  nested?: FeatureSchemaDraft[]
  specialData?: FeatureSchemaDraftSpecialData
  featureType?: AiH2oFeaturestoreApiV1FeatureSetProtoApi.FeatureType
  description?: string
  anomalyDetection?: boolean
  isPrimaryKey?: boolean
  isPartitionColumn?: boolean
}

export type FeatureSetDraftId = {
  featureSetDraftId?: string
}

export type ListFeatureSetDraftsRequest = {
  pageSize?: number
  pageToken?: string
}

export type ListableFeatureSetDraft = {
  featureSetDraftId?: string
  name?: string
  description?: string
  projectName?: string
  owner?: UserBasicInfo
  status?: ListableFeatureSetDraftFeatureSetDraftStatus
  errorMessage?: string
  jobId?: string
  expirationDate?: GoogleProtobufTimestamp.Timestamp
  draftType?: FeatureSetDraftType
}

export type FeatureSetDraft = {
  featureSetDraftId?: string
  projectId?: string
  name?: string
  description?: string
  schema?: FeatureSchemaDraft[]
  tags?: string[]
  draftType?: FeatureSetDraftType
  featureSetId?: string
  featureSetVersion?: string
  reason?: string
  derivedFrom?: DerivedInformation
}

export type ListFeatureSetDraftsResponse = {
  drafts?: ListableFeatureSetDraft[]
  nextPageToken?: string
}

export type FeatureSetDraftResponse = {
  featureSetDraft?: FeatureSetDraft
}

export type Artifact = {
  artifactId?: string
  title?: string
  description?: string
  filename?: string
  url?: string
  artifactType?: ArtifactType
  uploadStatus?: ArtifactUploadStatus
}

export type StoreFileArtifactRequest = {
  title?: string
  description?: string
  url?: string
  filename?: string
  featureSetId?: string
  featureSetMajorVersion?: number
  md5Checksum?: string
}

export type StoreFileArtifactResponse = {
  artifactId?: string
  filename?: string
  url?: string
  headers?: {[key: string]: string}
}

export type RetrieveArtifactRequest = {
  artifactId?: string
}

export type RetrieveArtifactResponse = {
  artifact?: Artifact
}

export type UpdateUploadStatusRequest = {
  artifactId?: string
  uploadStatus?: ArtifactUploadStatus
}

export type DeleteArtifactRequest = {
  artifactId?: string
}

export type ListArtifactsRequest = {
  featureSetId?: string
  featureSetMajorVersion?: number
  pageSize?: number
  pageToken?: string
}

export type ListArtifactsResponse = {
  artifacts?: Artifact[]
  nextPageToken?: string
}

export type StoreLinkRequest = {
  title?: string
  description?: string
  url?: string
  featureSetId?: string
  featureSetMajorVersion?: number
}

export type StoreLinkResponse = {
  artifactId?: string
}

export type FeatureSetPopularity = {
  featureSetId?: string
  numberOfRetrievals?: string
  featureSetName?: string
  featureSetDescription?: string
  permission?: ActivePermission
}

export type FeatureSetsPopularityResponse = {
  featureSets?: FeatureSetPopularity[]
}

export type ListFeatureSetsToReviewRequest = {
  pageSize?: number
  pageToken?: string
  filters?: ReviewStatus[]
  projectId?: string
}

export type ListFeatureSetsToReviewResponse = {
  entries?: FeatureSetToReview[]
  nextPageToken?: string
}

export type FeatureSetToReview = {
  reviewId?: string
  projectName?: string
  featureSetName?: string
  owner?: UserBasicInfo
  createdAt?: GoogleProtobufTimestamp.Timestamp
  status?: ReviewStatus
  featureSetId?: string
  featureSetMajorVersion?: number
}

export type ApproveReviewRequest = {
  reviewId?: string
  reason?: string
}

export type RejectReviewRequest = {
  reviewId?: string
  reason?: string
}

export type ListFeatureSetReviewsPageRequest = {
  filters?: ReviewStatus[]
  pageSize?: number
  pageToken?: string
  projectId?: string
}

export type FeatureSetReview = {
  reviewId?: string
  featureSetId?: string
  featureSetMajorVersion?: number
  featureSetName?: string
  projectName?: string
  status?: ReviewStatus
  reason?: string
  reviewer?: UserBasicInfo
  reviewedAt?: GoogleProtobufTimestamp.Timestamp
  createdAt?: GoogleProtobufTimestamp.Timestamp
}

export type ListFeatureSetReviewsPageResponse = {
  entries?: FeatureSetReview[]
  nextPageToken?: string
}

export type GetListableFeatureSetToReviewRequest = {
  reviewId?: string
}

export type GetListableFeatureSetToReviewResponse = {
  listableFeatureSet?: ListableFeatureSet
}

export type GetListableFeatureSetInReviewRequest = {
  reviewId?: string
}

export type GetListableFeatureSetInReviewResponse = {
  listableFeatureSet?: ListableFeatureSet
}

export type DeleteRejectedFeatureSetRequest = {
  reviewId?: string
}

export type ListFeaturesToReviewRequest = {
  reviewId?: string
  pageSize?: number
  pageToken?: string
  query?: string
}

export type ListFeaturesToReviewResponse = {
  features?: Feature[]
  nextPageToken?: string
}

export type ListFeaturesInReviewRequest = {
  reviewId?: string
  pageSize?: number
  pageToken?: string
  query?: string
}

export type ListFeaturesInReviewResponse = {
  features?: Feature[]
  nextPageToken?: string
}

export type GetFeatureSetPreviewToReviewRequest = {
  reviewId?: string
}

export type GetFeatureSetPreviewToReviewResponse = {
  previewUrl?: string
  maxColsNum?: number
}

export type GetFeatureSetPreviewInReviewRequest = {
  reviewId?: string
}

export type GetFeatureSetPreviewInReviewResponse = {
  previewUrl?: string
  maxColsNum?: number
}

export type GetFeatureSetToReviewRequest = {
  reviewId?: string
}

export type GetFeatureSetToReviewResponse = {
  featureSet?: FeatureSet
}

export type GetFeatureSetInReviewRequest = {
  reviewId?: string
}

export type GetFeatureSetInReviewResponse = {
  featureSet?: FeatureSet
}

export type RecentlyUsedProject = {
  projectId?: string
  projectName?: string
  projectDescription?: string
  updatedAt?: GoogleProtobufTimestamp.Timestamp
  lastAccessAt?: GoogleProtobufTimestamp.Timestamp
}

export type RecentlyUsedProjectsResponse = {
  projects?: RecentlyUsedProject[]
}

export type RecentlyUsedFeatureSet = {
  featureSetId?: string
  featureSetName?: string
  featureSetDescription?: string
  updatedAt?: GoogleProtobufTimestamp.Timestamp
  lastAccessAt?: GoogleProtobufTimestamp.Timestamp
}

export type RecentlyUsedFeatureSetsResponse = {
  featureSets?: RecentlyUsedFeatureSet[]
}

export type TargetFeatureRequest = {
  featureSetId?: string
  featureSetVersion?: string
  featureId?: string
}

export type ListTargetFeaturesRequest = {
  featureSetId?: string
  featureSetVersion?: string
}

export type TargetFeatureReference = {
  featureId?: string
  featureName?: string
}

export type ListTargetFeaturesResponse = {
  features?: TargetFeatureReference[]
}


type BaseListJobsPageByFeatureSetNameRequest = {
  pageSize?: number
  pageToken?: string
  featureSetNameQuery?: string
  jobTypeFilters?: JobType[]
}

export type ListJobsPageByFeatureSetNameRequest = BaseListJobsPageByFeatureSetNameRequest
  & OneOf<{ statusFilter: JobStatus }>


type BaseListJobsPageByFeatureSetIdRequest = {
  pageSize?: number
  pageToken?: string
  featureSetId?: string
  jobTypeFilters?: JobType[]
}

export type ListJobsPageByFeatureSetIdRequest = BaseListJobsPageByFeatureSetIdRequest
  & OneOf<{ statusFilter: JobStatus }>

export type FeatureSetJobRelatedInfo = {
  featureSetId?: string
  featureSetName?: string
  featureSetDescription?: string
}

export type ListableJob = {
  featureSetJobInfo?: FeatureSetJobRelatedInfo
  job?: Job
  childJobs?: ListableJob[]
  isDerived?: boolean
}

export type ListJobsPageResponse = {
  entries?: ListableJob[]
  nextPageToken?: string
}

export type GetJobsWithStatusCountRequest = {
  statusFilter?: JobStatus
}

export type GetJobsWithStatusCountResponse = {
  jobsCount?: number
}

export type PinFeatureSetRequest = {
  featureSetId?: string
}

export type UnpinFeatureSetRequest = {
  featureSetId?: string
}

export type PinnedFeatureSetsRequest = {
  pageSize?: number
  pageToken?: string
}

export type PinnedFeatureSet = {
  featureSetId?: string
  featureSetName?: string
  featureSetDescription?: string
  updatedAt?: GoogleProtobufTimestamp.Timestamp
  pinnedAt?: GoogleProtobufTimestamp.Timestamp
  userOrder?: string
}

export type PinnedFeatureSetsResponse = {
  featureSets?: PinnedFeatureSet[]
  nextPageToken?: string
}

export type IsFeatureSetPinnedRequest = {
  featureSetId?: string
}

export type IsFeatureSetPinnedResponse = {
  pinned?: boolean
}

export type CodeSnippedIdRequest = {
  featureSetId?: string
  featureSetMajorVersion?: number
}

export type CodeSnippedIdResponse = {
  artifactId?: string
}

export type AdvancedSearchOption = {
  searchOperator?: AdvancedSearchOptionSearchOperator
  searchField?: AdvancedSearchOptionSearchField
  searchValue?: string
}

export class CoreService {
  static ListJobs(req: ListJobsRequest, initReq?: fm.InitReq): Promise<ListJobsResponse> {
    return fm.fetchReq<ListJobsRequest, ListJobsResponse>(`/api/v1/jobs?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GetJob(req: JobId, initReq?: fm.InitReq): Promise<Job> {
    return fm.fetchReq<JobId, Job>(`/api/v1/jobs/${req["jobId"]}?${fm.renderURLSearchParams(req, ["jobId"])}`, {...initReq, method: "GET"})
  }
  static GetJobProgress(req: JobProgressInput, initReq?: fm.InitReq): Promise<JobProgressOutput> {
    return fm.fetchReq<JobProgressInput, JobProgressOutput>(`/api/v1/jobs/${req["jobId"]}/progress/${req["nextIndex"]}?${fm.renderURLSearchParams(req, ["jobId", "nextIndex"])}`, {...initReq, method: "GET"})
  }
  static CancelJob(req: JobId, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<JobId, GoogleProtobufEmpty.Empty>(`/api/v1/jobs/${req["jobId"]}`, {...initReq, method: "DELETE"})
  }
  static ListJobsPageByFeatureSetName(req: ListJobsPageByFeatureSetNameRequest, initReq?: fm.InitReq): Promise<ListJobsPageResponse> {
    return fm.fetchReq<ListJobsPageByFeatureSetNameRequest, ListJobsPageResponse>(`/api/v1/jobs/feature-set/name?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static ListJobsPageByFeatureSetId(req: ListJobsPageByFeatureSetIdRequest, initReq?: fm.InitReq): Promise<ListJobsPageResponse> {
    return fm.fetchReq<ListJobsPageByFeatureSetIdRequest, ListJobsPageResponse>(`/api/v1/jobs/feature-set/id?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GetJobsWithStatusCount(req: GetJobsWithStatusCountRequest, initReq?: fm.InitReq): Promise<GetJobsWithStatusCountResponse> {
    return fm.fetchReq<GetJobsWithStatusCountRequest, GetJobsWithStatusCountResponse>(`/api/v1/jobs/count-by-status?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static StartExtractSchemaJob(req: StartExtractSchemaJobRequest, initReq?: fm.InitReq): Promise<JobId> {
    return fm.fetchReq<StartExtractSchemaJobRequest, JobId>(`/api/v1/jobs/extract-schema`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static GetExtractSchemaJobOutput(req: JobId, initReq?: fm.InitReq): Promise<ExtractSchemaResponse> {
    return fm.fetchReq<JobId, ExtractSchemaResponse>(`/api/v1/jobs/${req["jobId"]}/output/extract-schema?${fm.renderURLSearchParams(req, ["jobId"])}`, {...initReq, method: "GET"})
  }
  static StartIngestJob(req: StartIngestJobRequest, initReq?: fm.InitReq): Promise<JobId> {
    return fm.fetchReq<StartIngestJobRequest, JobId>(`/api/v1/ingest/start`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static GetIngestJobOutput(req: JobId, initReq?: fm.InitReq): Promise<IngestResponse> {
    return fm.fetchReq<JobId, IngestResponse>(`/api/v1/jobs/${req["jobId"]}/output/ingestion?${fm.renderURLSearchParams(req, ["jobId"])}`, {...initReq, method: "GET"})
  }
  static StartRetrieveAsLinksJob(req: RetrieveRequest, initReq?: fm.InitReq): Promise<JobId> {
    return fm.fetchReq<RetrieveRequest, JobId>(`/api/v1/feature-sets/retrieve`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static GetRetrieveAsLinksJobOutput(req: JobId, initReq?: fm.InitReq): Promise<RetrieveAsLinksResponse> {
    return fm.fetchReq<JobId, RetrieveAsLinksResponse>(`/api/v1/feature-sets/retrieve/${req["jobId"]}?${fm.renderURLSearchParams(req, ["jobId"])}`, {...initReq, method: "GET"})
  }
  static RetrieveAsSpark(req: RetrieveRequest, initReq?: fm.InitReq): Promise<RetrieveAsSparkResponse> {
    return fm.fetchReq<RetrieveRequest, RetrieveAsSparkResponse>(`/api/v1/feature-sets/retrieve/as-spark`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static StartRevertIngestJob(req: StartRevertIngestJobRequest, initReq?: fm.InitReq): Promise<JobId> {
    return fm.fetchReq<StartRevertIngestJobRequest, JobId>(`/api/v1/ingest/revert`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static GetRevertIngestJobOutput(req: JobId, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<JobId, GoogleProtobufEmpty.Empty>(`/api/v1/jobs/${req["jobId"]}/output/revert?${fm.renderURLSearchParams(req, ["jobId"])}`, {...initReq, method: "GET"})
  }
  static HasPermissionToRetrieve(req: HasPermissionToRetrieveRequest, initReq?: fm.InitReq): Promise<HasPermissionToRetrieveResponse> {
    return fm.fetchReq<HasPermissionToRetrieveRequest, HasPermissionToRetrieveResponse>(`/api/v1/feature-sets/retrieve/permission/${req["projectName"]}/${req["featureSetName"]}?${fm.renderURLSearchParams(req, ["projectName", "featureSetName"])}`, {...initReq, method: "GET"})
  }
  static RegisterFeatureSet(req: RegisterFeatureSetRequest, initReq?: fm.InitReq): Promise<FeatureSetResponse> {
    return fm.fetchReq<RegisterFeatureSetRequest, FeatureSetResponse>(`/api/v1/feature-sets`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static CreateNewFeatureSetVersion(req: CreateNewFeatureSetVersionRequest, initReq?: fm.InitReq): Promise<FeatureSetResponse> {
    return fm.fetchReq<CreateNewFeatureSetVersionRequest, FeatureSetResponse>(`/api/v1/feature-sets/${req["featureSetId"]}/version`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static GetOnlineRetrieveMeta(req: GoogleProtobufEmpty.Empty, initReq?: fm.InitReq): Promise<OnlineRetrieveMeta> {
    return fm.fetchReq<GoogleProtobufEmpty.Empty, OnlineRetrieveMeta>(`/api/v1/online-retrieve?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GetVersion(req: GoogleProtobufEmpty.Empty, initReq?: fm.InitReq): Promise<GetVersionResponse> {
    return fm.fetchReq<GoogleProtobufEmpty.Empty, GetVersionResponse>(`/api/v1/version?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GetFeatureSet(req: GetFeatureSetRequest, initReq?: fm.InitReq): Promise<FeatureSetResponse> {
    return fm.fetchReq<GetFeatureSetRequest, FeatureSetResponse>(`/api/v1/projects/${req["projectId"]}/feature-sets/${req["featureSetName"]}?${fm.renderURLSearchParams(req, ["projectId", "featureSetName"])}`, {...initReq, method: "GET"})
  }
  static GetFeatureSetById(req: FeatureSetRequestId, initReq?: fm.InitReq): Promise<FeatureSetResponse> {
    return fm.fetchReq<FeatureSetRequestId, FeatureSetResponse>(`/api/v1/feature-sets/${req["featureSetId"]}?${fm.renderURLSearchParams(req, ["featureSetId"])}`, {...initReq, method: "GET"})
  }
  static GetFeatureSetsLastMinorForCurrentMajor(req: GetFeatureSetsLastMinorForCurrentMajorRequest, initReq?: fm.InitReq): Promise<FeatureSetResponse> {
    return fm.fetchReq<GetFeatureSetsLastMinorForCurrentMajorRequest, FeatureSetResponse>(`/api/v1/feature-sets/${req["featureSetId"]}/last?${fm.renderURLSearchParams(req, ["featureSetId"])}`, {...initReq, method: "GET"})
  }
  static GetLastMinorFeatureSetForMajorInProject(req: GetLastMinorFeatureSetForMajorInProjectRequest, initReq?: fm.InitReq): Promise<FeatureSetResponse> {
    return fm.fetchReq<GetLastMinorFeatureSetForMajorInProjectRequest, FeatureSetResponse>(`/api/v1/projects/${req["projectId"]}/feature-sets/${req["featureSetName"]}/${req["featureSetMajorVersion"]}/last?${fm.renderURLSearchParams(req, ["projectId", "featureSetName", "featureSetMajorVersion"])}`, {...initReq, method: "GET"})
  }
  static ListFeatureSetVersions(req: ListFeatureSetsVersionRequest, initReq?: fm.InitReq): Promise<ListFeatureSetVersionsResponse> {
    return fm.fetchReq<ListFeatureSetsVersionRequest, ListFeatureSetVersionsResponse>(`/api/v1/feature-sets/${req["featureSetId"]}/versions?${fm.renderURLSearchParams(req, ["featureSetId"])}`, {...initReq, method: "GET"})
  }
  static DeleteFeatureSet(req: DeleteFeatureSetRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<DeleteFeatureSetRequest, GoogleProtobufEmpty.Empty>(`/api/v1/feature-sets/${req["featureSetId"]}`, {...initReq, method: "DELETE"})
  }
  static DeleteFeatureSetVersion(req: DeleteFeatureSetVersionRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<DeleteFeatureSetVersionRequest, GoogleProtobufEmpty.Empty>(`/api/v1/feature-sets/${req["featureSetId"]}/versions/${req["featureSetMajorVersion"]}`, {...initReq, method: "DELETE"})
  }
  static ListFeatureSetsPage(req: ListFeatureSetsPageRequest, initReq?: fm.InitReq): Promise<ListFeatureSetsPageResponse> {
    return fm.fetchReq<ListFeatureSetsPageRequest, ListFeatureSetsPageResponse>(`/api/v1/feature-sets?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static FeatureSetExists(req: FeatureSetExistsRequest, initReq?: fm.InitReq): Promise<ExistsResponse> {
    return fm.fetchReq<FeatureSetExistsRequest, ExistsResponse>(`/api/v1/feature-sets/exists/${req["featureSetId"]}?${fm.renderURLSearchParams(req, ["featureSetId"])}`, {...initReq, method: "GET"})
  }
  static GetIngestHistory(req: GetIngestHistoryRequest, initReq?: fm.InitReq): Promise<GetIngestHistoryResponse> {
    return fm.fetchReq<GetIngestHistoryRequest, GetIngestHistoryResponse>(`/api/v1/ingest/${req["featureSetId"]}/${req["featureSetVersion"]}/history?${fm.renderURLSearchParams(req, ["featureSetId", "featureSetVersion"])}`, {...initReq, method: "GET"})
  }
  static IsFeatureSetSchemaCompatible(req: FeatureSetSchemaCompatibilityRequest, initReq?: fm.InitReq): Promise<FeatureSetSchemaCompatibilityResponse> {
    return fm.fetchReq<FeatureSetSchemaCompatibilityRequest, FeatureSetSchemaCompatibilityResponse>(`/api/v1/feature-sets/features/schema-compatible`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static FeatureSetSchemaPatch(req: FeatureSetSchemaPatchRequest, initReq?: fm.InitReq): Promise<FeatureSetSchemaPatchResponse> {
    return fm.fetchReq<FeatureSetSchemaPatchRequest, FeatureSetSchemaPatchResponse>(`/api/v1/feature-sets/features/schema-patch`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static GetFeatureSetPreview(req: GetFeatureSetPreviewRequest, initReq?: fm.InitReq): Promise<GetFeatureSetPreviewResponse> {
    return fm.fetchReq<GetFeatureSetPreviewRequest, GetFeatureSetPreviewResponse>(`/api/v1/feature-sets/${req["featureSetId"]}/preview?${fm.renderURLSearchParams(req, ["featureSetId"])}`, {...initReq, method: "GET"})
  }
  static UpdateFeatureSet(req: UpdateFeatureSetRequest, initReq?: fm.InitReq): Promise<UpdateFeatureSetResponse> {
    return fm.fetchReq<UpdateFeatureSetRequest, UpdateFeatureSetResponse>(`/api/v1/feature-sets/${req["featureSetId"]}`, {...initReq, method: "PUT", body: JSON.stringify(req, fm.replacer)})
  }
  static StartOptimizeStorageJob(req: StartOptimizeStorageJobRequest, initReq?: fm.InitReq): Promise<JobId> {
    return fm.fetchReq<StartOptimizeStorageJobRequest, JobId>(`/api/v1/jobs/optimize-storage/start`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static GetOptimizeStorageJobOutput(req: JobId, initReq?: fm.InitReq): Promise<OptimizeStorageResponse> {
    return fm.fetchReq<JobId, OptimizeStorageResponse>(`/api/v1/jobs/${req["jobId"]}/output/optimize-storage?${fm.renderURLSearchParams(req, ["jobId"])}`, {...initReq, method: "GET"})
  }
  static ListProjectsPage(req: ListProjectsPageRequest, initReq?: fm.InitReq): Promise<ListProjectsPageResponse> {
    return fm.fetchReq<ListProjectsPageRequest, ListProjectsPageResponse>(`/api/v1/projects?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static CreateProject(req: CreateProjectRequest, initReq?: fm.InitReq): Promise<CreateProjectResponse> {
    return fm.fetchReq<CreateProjectRequest, CreateProjectResponse>(`/api/v1/projects`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static GetProject(req: GetProjectRequest, initReq?: fm.InitReq): Promise<ProjectResponse> {
    return fm.fetchReq<GetProjectRequest, ProjectResponse>(`/ai.h2o.featurestore.api.v1.CoreService/GetProject`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static GetProjectById(req: GetProjectByIdRequest, initReq?: fm.InitReq): Promise<ProjectResponse> {
    return fm.fetchReq<GetProjectByIdRequest, ProjectResponse>(`/api/v1/projects/${req["projectId"]}?${fm.renderURLSearchParams(req, ["projectId"])}`, {...initReq, method: "GET"})
  }
  static DeleteProject(req: DeleteProjectRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<DeleteProjectRequest, GoogleProtobufEmpty.Empty>(`/api/v1/projects/${req["projectId"]}`, {...initReq, method: "DELETE"})
  }
  static ProjectExists(req: ProjectExistsRequest, initReq?: fm.InitReq): Promise<ExistsResponse> {
    return fm.fetchReq<ProjectExistsRequest, ExistsResponse>(`/api/v1/projects/${req["projectId"]}/exists?${fm.renderURLSearchParams(req, ["projectId"])}`, {...initReq, method: "GET"})
  }
  static UpdateProject(req: UpdateProjectRequest, initReq?: fm.InitReq): Promise<UpdateProjectResponse> {
    return fm.fetchReq<UpdateProjectRequest, UpdateProjectResponse>(`/api/v1/projects/${req["projectId"]}`, {...initReq, method: "PUT", body: JSON.stringify(req, fm.replacer)})
  }
  static ListProjectHistoryPage(req: ListProjectHistoryPageRequest, initReq?: fm.InitReq): Promise<ListProjectHistoryPageResponse> {
    return fm.fetchReq<ListProjectHistoryPageRequest, ListProjectHistoryPageResponse>(`/api/v1/projects/${req["projectId"]}/history?${fm.renderURLSearchParams(req, ["projectId"])}`, {...initReq, method: "GET"})
  }
  static GetActiveUser(req: GoogleProtobufEmpty.Empty, initReq?: fm.InitReq): Promise<GetActiveUserResponse> {
    return fm.fetchReq<GoogleProtobufEmpty.Empty, GetActiveUserResponse>(`/api/v1/auth/users?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GetWebConfig(req: GoogleProtobufEmpty.Empty, initReq?: fm.InitReq): Promise<GetWebConfigResponse> {
    return fm.fetchReq<GoogleProtobufEmpty.Empty, GetWebConfigResponse>(`/api/v1/config?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GetApiConfig(req: GoogleProtobufEmpty.Empty, initReq?: fm.InitReq): Promise<GetApiConfigResponse> {
    return fm.fetchReq<GoogleProtobufEmpty.Empty, GetApiConfigResponse>(`/api/v1/api-config?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GetH2OGpteConfig(req: GoogleProtobufEmpty.Empty, initReq?: fm.InitReq): Promise<GetGpteConfigResponse> {
    return fm.fetchReq<GoogleProtobufEmpty.Empty, GetGpteConfigResponse>(`/api/v1/h2o-gpte-config?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static AddFeatureSetPermission(req: FeatureSetPermissionRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<FeatureSetPermissionRequest, GoogleProtobufEmpty.Empty>(`/api/v1/permissions/feature-sets/add/permission/${req["featureSetId"]}`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static AddProjectPermission(req: ProjectPermissionRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<ProjectPermissionRequest, GoogleProtobufEmpty.Empty>(`/api/v1/permissions/projects/add/permission/${req["projectId"]}`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static RemoveFeatureSetPermission(req: FeatureSetPermissionRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<FeatureSetPermissionRequest, GoogleProtobufEmpty.Empty>(`/api/v1/permissions/feature-sets/remove/permission/${req["featureSetId"]}`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static RemoveProjectPermission(req: ProjectPermissionRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<ProjectPermissionRequest, GoogleProtobufEmpty.Empty>(`/api/v1/permissions/projects/remove/permission/${req["projectId"]}`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static SubmitPendingProjectPermission(req: SubmitPendingPermissionRequest, initReq?: fm.InitReq): Promise<SubmitPendingPermissionResponse> {
    return fm.fetchReq<SubmitPendingPermissionRequest, SubmitPendingPermissionResponse>(`/api/v1/permissions/projects/${req["resourceId"]}`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static SubmitPendingFeatureSetPermission(req: SubmitPendingPermissionRequest, initReq?: fm.InitReq): Promise<SubmitPendingPermissionResponse> {
    return fm.fetchReq<SubmitPendingPermissionRequest, SubmitPendingPermissionResponse>(`/api/v1/permissions/feature-sets/${req["resourceId"]}`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static ListProjectPermissionsPage(req: ListPermissionsPageRequest, initReq?: fm.InitReq): Promise<ListProjectsPermissionsPageResponse> {
    return fm.fetchReq<ListPermissionsPageRequest, ListProjectsPermissionsPageResponse>(`/api/v1/permissions/projects?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static ListFeatureSetsPermissionsPage(req: ListPermissionsPageRequest, initReq?: fm.InitReq): Promise<ListFeatureSetsPermissionsPageResponse> {
    return fm.fetchReq<ListPermissionsPageRequest, ListFeatureSetsPermissionsPageResponse>(`/api/v1/permissions/feature-sets?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static ListManageableProjectPermissionsPage(req: ListPermissionsPageRequest, initReq?: fm.InitReq): Promise<ListProjectsPermissionsPageResponse> {
    return fm.fetchReq<ListPermissionsPageRequest, ListProjectsPermissionsPageResponse>(`/api/v1/permissions/manageable-projects?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static ListManageableFeatureSetsPermissionsPage(req: ListPermissionsPageRequest, initReq?: fm.InitReq): Promise<ListFeatureSetsPermissionsPageResponse> {
    return fm.fetchReq<ListPermissionsPageRequest, ListFeatureSetsPermissionsPageResponse>(`/api/v1/permissions/manageable-feature-sets?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static ApprovePendingPermission(req: ApprovePendingPermissionRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<ApprovePendingPermissionRequest, GoogleProtobufEmpty.Empty>(`/api/v1/permissions/approval`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static RejectPendingPermission(req: RejectPendingPermissionRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<RejectPendingPermissionRequest, GoogleProtobufEmpty.Empty>(`/api/v1/permissions/rejection`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static WithdrawPendingPermission(req: WithdrawPendingPermissionRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<WithdrawPendingPermissionRequest, GoogleProtobufEmpty.Empty>(`/api/v1/permissions/withdraw`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static RevokePermission(req: RevokePermissionRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<RevokePermissionRequest, GoogleProtobufEmpty.Empty>(`/api/v1/permissions/revoke`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static GetActiveProjectPermission(req: GetActivePermissionRequest, initReq?: fm.InitReq): Promise<GetActivePermissionResponse> {
    return fm.fetchReq<GetActivePermissionRequest, GetActivePermissionResponse>(`/api/v1/permissions/projects/${req["resourceId"]}/active?${fm.renderURLSearchParams(req, ["resourceId"])}`, {...initReq, method: "GET"})
  }
  static GetActiveFeatureSetPermission(req: GetActivePermissionRequest, initReq?: fm.InitReq): Promise<GetActivePermissionResponse> {
    return fm.fetchReq<GetActivePermissionRequest, GetActivePermissionResponse>(`/api/v1/permissions/feature-sets/${req["resourceId"]}/active?${fm.renderURLSearchParams(req, ["resourceId"])}`, {...initReq, method: "GET"})
  }
  static GetUserProjectPermissions(req: GetUserPermissionsRequest, initReq?: fm.InitReq): Promise<GetUserPermissionsResponse> {
    return fm.fetchReq<GetUserPermissionsRequest, GetUserPermissionsResponse>(`/api/v1/permissions/projects/${req["resourceId"]}?${fm.renderURLSearchParams(req, ["resourceId"])}`, {...initReq, method: "GET"})
  }
  static GetUserFeatureSetPermissions(req: GetUserPermissionsRequest, initReq?: fm.InitReq): Promise<GetUserPermissionsResponse> {
    return fm.fetchReq<GetUserPermissionsRequest, GetUserPermissionsResponse>(`/api/v1/permissions/feature-sets/${req["resourceId"]}?${fm.renderURLSearchParams(req, ["resourceId"])}`, {...initReq, method: "GET"})
  }
  static GetUserActiveProjectPermissions(req: GetUserActivePermissionsRequest, initReq?: fm.InitReq): Promise<GetUserPermissionsResponse> {
    return fm.fetchReq<GetUserActivePermissionsRequest, GetUserPermissionsResponse>(`/api/v1/permissions/projects/active/${req["resourceId"]}?${fm.renderURLSearchParams(req, ["resourceId"])}`, {...initReq, method: "GET"})
  }
  static GetUserActiveFeatureSetPermissions(req: GetUserActivePermissionsRequest, initReq?: fm.InitReq): Promise<GetUserPermissionsResponse> {
    return fm.fetchReq<GetUserActivePermissionsRequest, GetUserPermissionsResponse>(`/api/v1/permissions/feature-sets/active/${req["resourceId"]}?${fm.renderURLSearchParams(req, ["resourceId"])}`, {...initReq, method: "GET"})
  }
  static GetUsersWithoutProjectPermissions(req: GetUsersWithoutPermissionRequest, initReq?: fm.InitReq): Promise<GetUsersWithoutPermissionResponse> {
    return fm.fetchReq<GetUsersWithoutPermissionRequest, GetUsersWithoutPermissionResponse>(`/api/v1/permissions/projects/${req["resourceId"]}/user/permission/none?${fm.renderURLSearchParams(req, ["resourceId"])}`, {...initReq, method: "GET"})
  }
  static GetUsersWithoutFeatureSetPermissions(req: GetUsersWithoutPermissionRequest, initReq?: fm.InitReq): Promise<GetUsersWithoutPermissionResponse> {
    return fm.fetchReq<GetUsersWithoutPermissionRequest, GetUsersWithoutPermissionResponse>(`/api/v1/permissions/feature-sets/${req["resourceId"]}/user/permission/none?${fm.renderURLSearchParams(req, ["resourceId"])}`, {...initReq, method: "GET"})
  }
  static RevokeToken(req: TokenRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<TokenRequest, GoogleProtobufEmpty.Empty>(`/api/v1/auth/tokens/${req["tokenId"]}`, {...initReq, method: "DELETE"})
  }
  static GenerateToken(req: GenerateTokenRequest, initReq?: fm.InitReq): Promise<RawTokenResponse> {
    return fm.fetchReq<GenerateTokenRequest, RawTokenResponse>(`/api/v1/auth/tokens`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static ListPersonalAccessTokens(req: ListPersonalAccessTokensRequest, initReq?: fm.InitReq): Promise<ListPersonalAccessTokensResponse> {
    return fm.fetchReq<ListPersonalAccessTokensRequest, ListPersonalAccessTokensResponse>(`/api/v1/auth/tokens?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GetToken(req: TokenRequest, initReq?: fm.InitReq): Promise<TokenResponse> {
    return fm.fetchReq<TokenRequest, TokenResponse>(`/api/v1/auth/tokens/${req["tokenId"]}?${fm.renderURLSearchParams(req, ["tokenId"])}`, {...initReq, method: "GET"})
  }
  static GetTokensConfig(req: GoogleProtobufEmpty.Empty, initReq?: fm.InitReq): Promise<TokensConfigResponse> {
    return fm.fetchReq<GoogleProtobufEmpty.Empty, TokensConfigResponse>(`/api/v1/auth/tokens/config?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GenerateIngestToken(req: AiH2oFeaturestoreApiV1OnlineApi.OnlineIngestionTokenRequest, initReq?: fm.InitReq): Promise<AiH2oFeaturestoreApiV1OnlineApi.OnlineIngestionTokenResponse> {
    return fm.fetchReq<AiH2oFeaturestoreApiV1OnlineApi.OnlineIngestionTokenRequest, AiH2oFeaturestoreApiV1OnlineApi.OnlineIngestionTokenResponse>(`/api/v1/feature-sets/${req["featureSetId"]}/${req["featureSetVersion"]}/online/token?${fm.renderURLSearchParams(req, ["featureSetId", "featureSetVersion"])}`, {...initReq, method: "GET"})
  }
  static GenerateOnlineRetrievalToken(req: AiH2oFeaturestoreApiV1OnlineApi.OnlineRetrieveTokenRequest, initReq?: fm.InitReq): Promise<AiH2oFeaturestoreApiV1OnlineApi.OnlineRetrieveTokenResponse> {
    return fm.fetchReq<AiH2oFeaturestoreApiV1OnlineApi.OnlineRetrieveTokenRequest, AiH2oFeaturestoreApiV1OnlineApi.OnlineRetrieveTokenResponse>(`/api/v1/feature-sets/${req["featureSetId"]}/${req["featureSetVersion"]}/online/retrieval/token?${fm.renderURLSearchParams(req, ["featureSetId", "featureSetVersion"])}`, {...initReq, method: "GET"})
  }
  static StartMaterializationOnlineJob(req: StartMaterializationOnlineRequest, initReq?: fm.InitReq): Promise<JobId> {
    return fm.fetchReq<StartMaterializationOnlineRequest, JobId>(`/api/v1/feature-sets/${req["featureSetId"]}/${req["featureSetVersion"]}/online-materialization`, {...initReq, method: "POST"})
  }
  static GetMaterializationOnlineJobOutput(req: JobId, initReq?: fm.InitReq): Promise<MaterializationOnlineResponse> {
    return fm.fetchReq<JobId, MaterializationOnlineResponse>(`/api/v1/jobs/${req["jobId"]}/output/online-materialization?${fm.renderURLSearchParams(req, ["jobId"])}`, {...initReq, method: "GET"})
  }
  static StartOnlineOfflineIngestionJob(req: StartOnlineOfflineIngestionRequest, initReq?: fm.InitReq): Promise<JobId> {
    return fm.fetchReq<StartOnlineOfflineIngestionRequest, JobId>(`/api/v1/feature-sets/${req["featureSetId"]}/${req["featureSetVersion"]}/online-offline-ingestion`, {...initReq, method: "POST"})
  }
  static GetComputeStatisticsJobOutput(req: JobId, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<JobId, GoogleProtobufEmpty.Empty>(`/api/v1/jobs/${req["jobId"]}/output/compute-statistics?${fm.renderURLSearchParams(req, ["jobId"])}`, {...initReq, method: "GET"})
  }
  static GetComputeRecommendationClassifiersJobOutput(req: JobId, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<JobId, GoogleProtobufEmpty.Empty>(`/api/v1/jobs/${req["jobId"]}/output/recommendation-classifiers-computation?${fm.renderURLSearchParams(req, ["jobId"])}`, {...initReq, method: "GET"})
  }
  static GenerateTransformationUpload(req: GenerateTransformationUploadRequest, initReq?: fm.InitReq): Promise<GenerateTransformationUploadResponse> {
    return fm.fetchReq<GenerateTransformationUploadRequest, GenerateTransformationUploadResponse>(`/api/v1/upload/transformations`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static GenerateTemporaryUpload(req: GenerateTemporaryUploadRequest, initReq?: fm.InitReq): Promise<GenerateTemporaryUploadResponse> {
    return fm.fetchReq<GenerateTemporaryUploadRequest, GenerateTemporaryUploadResponse>(`/api/v1/upload/temporary`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static ListRecommendationClassifiers(req: GoogleProtobufEmpty.Empty, initReq?: fm.InitReq): Promise<AiH2oFeaturestoreApiV1RecommendationProtoApi.ListRecommendationClassifierResponse> {
    return fm.fetchReq<GoogleProtobufEmpty.Empty, AiH2oFeaturestoreApiV1RecommendationProtoApi.ListRecommendationClassifierResponse>(`/api/v1/classifiers?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static CreateRecommendationClassifier(req: AiH2oFeaturestoreApiV1RecommendationProtoApi.CreateRecommendationClassifierRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<AiH2oFeaturestoreApiV1RecommendationProtoApi.CreateRecommendationClassifierRequest, GoogleProtobufEmpty.Empty>(`/api/v1/classifiers`, {...initReq, method: "POST", body: JSON.stringify(req["classifier"], fm.replacer)})
  }
  static UpdateRecommendationClassifier(req: AiH2oFeaturestoreApiV1RecommendationProtoApi.UpdateRecommendationClassifierRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<AiH2oFeaturestoreApiV1RecommendationProtoApi.UpdateRecommendationClassifierRequest, GoogleProtobufEmpty.Empty>(`/api/v1/classifiers/${req["classifierName"]}`, {...initReq, method: "PUT", body: JSON.stringify(req["classifier"], fm.replacer)})
  }
  static DeleteRecommendationClassifier(req: AiH2oFeaturestoreApiV1RecommendationProtoApi.DeleteRecommendationClassifierRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<AiH2oFeaturestoreApiV1RecommendationProtoApi.DeleteRecommendationClassifierRequest, GoogleProtobufEmpty.Empty>(`/api/v1/classifiers/${req["classifierName"]}`, {...initReq, method: "DELETE"})
  }
  static GetRecommendations(req: GetRecommendationRequest, initReq?: fm.InitReq): Promise<GetRecommendationResponse> {
    return fm.fetchReq<GetRecommendationRequest, GetRecommendationResponse>(`/api/v1/feature-sets/${req["featureSetId"]}/recommendations?${fm.renderURLSearchParams(req, ["featureSetId"])}`, {...initReq, method: "GET"})
  }
  static GetDashboard(req: GoogleProtobufEmpty.Empty, initReq?: fm.InitReq): Promise<AiH2oFeaturestoreApiV1DashboardApi.DashboardResponse> {
    return fm.fetchReq<GoogleProtobufEmpty.Empty, AiH2oFeaturestoreApiV1DashboardApi.DashboardResponse>(`/api/v1/dashboard?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GetFeatureSetsPopularity(req: GoogleProtobufEmpty.Empty, initReq?: fm.InitReq): Promise<FeatureSetsPopularityResponse> {
    return fm.fetchReq<GoogleProtobufEmpty.Empty, FeatureSetsPopularityResponse>(`/api/v1/dashboard/popular-feature-sets?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GetRecentlyUsedProjects(req: GoogleProtobufEmpty.Empty, initReq?: fm.InitReq): Promise<RecentlyUsedProjectsResponse> {
    return fm.fetchReq<GoogleProtobufEmpty.Empty, RecentlyUsedProjectsResponse>(`/api/v1/dashboard/recently-used-projects?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GetRecentlyUsedFeatureSets(req: GoogleProtobufEmpty.Empty, initReq?: fm.InitReq): Promise<RecentlyUsedFeatureSetsResponse> {
    return fm.fetchReq<GoogleProtobufEmpty.Empty, RecentlyUsedFeatureSetsResponse>(`/api/v1/dashboard/recently-used-feature-sets?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static PinFeatureSet(req: PinFeatureSetRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<PinFeatureSetRequest, GoogleProtobufEmpty.Empty>(`/api/v1/dashboard/pinned-feature-sets/${req["featureSetId"]}`, {...initReq, method: "PUT"})
  }
  static UnpinFeatureSet(req: UnpinFeatureSetRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<UnpinFeatureSetRequest, GoogleProtobufEmpty.Empty>(`/api/v1/dashboard/pinned-feature-sets/${req["featureSetId"]}`, {...initReq, method: "DELETE"})
  }
  static IsFeatureSetPinned(req: IsFeatureSetPinnedRequest, initReq?: fm.InitReq): Promise<IsFeatureSetPinnedResponse> {
    return fm.fetchReq<IsFeatureSetPinnedRequest, IsFeatureSetPinnedResponse>(`/api/v1/dashboard/pinned-feature-sets/exists/${req["featureSetId"]}?${fm.renderURLSearchParams(req, ["featureSetId"])}`, {...initReq, method: "GET"})
  }
  static ListPinnedFeatureSets(req: PinnedFeatureSetsRequest, initReq?: fm.InitReq): Promise<PinnedFeatureSetsResponse> {
    return fm.fetchReq<PinnedFeatureSetsRequest, PinnedFeatureSetsResponse>(`/api/v1/dashboard/pinned-feature-sets?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static SearchProjects(req: ProjectSearchRequest, initReq?: fm.InitReq): Promise<ProjectSearchResults> {
    return fm.fetchReq<ProjectSearchRequest, ProjectSearchResults>(`/api/v1/search/projects?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static AdminSearchProjects(req: AdminProjectSearchRequest, initReq?: fm.InitReq): Promise<ProjectSearchResults> {
    return fm.fetchReq<AdminProjectSearchRequest, ProjectSearchResults>(`/api/v1/admin/search/projects?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static SearchFeatureSets(req: FeatureSetSearchRequest, initReq?: fm.InitReq): Promise<FeatureSetSearchResults> {
    return fm.fetchReq<FeatureSetSearchRequest, FeatureSetSearchResults>(`/api/v1/search/feature-sets`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static SearchFeatures(req: FeatureSearchRequest, initReq?: fm.InitReq): Promise<FeatureSearchResults> {
    return fm.fetchReq<FeatureSearchRequest, FeatureSearchResults>(`/api/v1/search/features?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GetFeature(req: GetFeatureRequest, initReq?: fm.InitReq): Promise<FeatureResponse> {
    return fm.fetchReq<GetFeatureRequest, FeatureResponse>(`/api/v1/feature-sets/${req["featureSetId"]}/features/${req["featureId"]}?${fm.renderURLSearchParams(req, ["featureSetId", "featureId"])}`, {...initReq, method: "GET"})
  }
  static ListFeatures(req: ListFeaturesRequest, initReq?: fm.InitReq): Promise<ListFeaturesResponse> {
    return fm.fetchReq<ListFeaturesRequest, ListFeaturesResponse>(`/api/v1/feature-sets/${req["featureSetId"]}/features?${fm.renderURLSearchParams(req, ["featureSetId"])}`, {...initReq, method: "GET"})
  }
  static UpdateFeature(req: UpdateFeatureRequest, initReq?: fm.InitReq): Promise<UpdateFeatureResponse> {
    return fm.fetchReq<UpdateFeatureRequest, UpdateFeatureResponse>(`/api/v1/feature-sets/${req["featureSetId"]}/features/${req["featureId"]}`, {...initReq, method: "PUT", body: JSON.stringify(req, fm.replacer)})
  }
  static MarkFeatureAsTarget(req: TargetFeatureRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<TargetFeatureRequest, GoogleProtobufEmpty.Empty>(`/api/v1/feature-sets/${req["featureSetId"]}/target-variables/${req["featureId"]}`, {...initReq, method: "PUT"})
  }
  static DiscardFeatureAsTarget(req: TargetFeatureRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<TargetFeatureRequest, GoogleProtobufEmpty.Empty>(`/api/v1/feature-sets/${req["featureSetId"]}/target-variables/${req["featureId"]}`, {...initReq, method: "DELETE"})
  }
  static ListTargetFeatures(req: ListTargetFeaturesRequest, initReq?: fm.InitReq): Promise<ListTargetFeaturesResponse> {
    return fm.fetchReq<ListTargetFeaturesRequest, ListTargetFeaturesResponse>(`/api/v1/feature-sets/${req["featureSetId"]}/target-variables?${fm.renderURLSearchParams(req, ["featureSetId"])}`, {...initReq, method: "GET"})
  }
  static GetListableFeatureSet(req: ListableFeatureSetRequest, initReq?: fm.InitReq): Promise<ListableFeatureSetResponse> {
    return fm.fetchReq<ListableFeatureSetRequest, ListableFeatureSetResponse>(`/api/v1/feature-sets/${req["featureSetId"]}/listable?${fm.renderURLSearchParams(req, ["featureSetId"])}`, {...initReq, method: "GET"})
  }
  static GetFeatureSetsDerivedFrom(req: FeatureSetsDerivedFromRequest, initReq?: fm.InitReq): Promise<FeatureSetsDerivedFromResponse> {
    return fm.fetchReq<FeatureSetsDerivedFromRequest, FeatureSetsDerivedFromResponse>(`/api/v1/feature-sets/${req["featureSetId"]}/derived-from?${fm.renderURLSearchParams(req, ["featureSetId"])}`, {...initReq, method: "GET"})
  }
  static ScheduleIngestJob(req: ScheduleTaskRequest, initReq?: fm.InitReq): Promise<ScheduledTaskResponse> {
    return fm.fetchReq<ScheduleTaskRequest, ScheduledTaskResponse>(`/api/v1/schedules/ingestion`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static ListScheduledTasks(req: ListScheduledTasksRequest, initReq?: fm.InitReq): Promise<ListScheduledTasksResponse> {
    return fm.fetchReq<ListScheduledTasksRequest, ListScheduledTasksResponse>(`/api/v1/feature-sets/${req["featureSetId"]}/schedules?${fm.renderURLSearchParams(req, ["featureSetId"])}`, {...initReq, method: "GET"})
  }
  static GetScheduledTask(req: ScheduledTaskId, initReq?: fm.InitReq): Promise<ScheduledTaskResponse> {
    return fm.fetchReq<ScheduledTaskId, ScheduledTaskResponse>(`/api/v1/schedules/${req["scheduledTaskId"]}?${fm.renderURLSearchParams(req, ["scheduledTaskId"])}`, {...initReq, method: "GET"})
  }
  static DeleteScheduledTask(req: ScheduledTaskId, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<ScheduledTaskId, GoogleProtobufEmpty.Empty>(`/api/v1/schedules/${req["scheduledTaskId"]}`, {...initReq, method: "DELETE"})
  }
  static UpdateScheduledTask(req: ScheduledTaskUpdateRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<ScheduledTaskUpdateRequest, GoogleProtobufEmpty.Empty>(`/api/v1/schedules/${req["scheduledTaskId"]}`, {...initReq, method: "PUT", body: JSON.stringify(req, fm.replacer)})
  }
  static PauseScheduledTask(req: PauseScheduledTaskRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<PauseScheduledTaskRequest, GoogleProtobufEmpty.Empty>(`/api/v1/schedules/${req["scheduledTaskId"]}/pause`, {...initReq, method: "PUT"})
  }
  static ResumeScheduledTask(req: ResumeScheduledTaskRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<ResumeScheduledTaskRequest, GoogleProtobufEmpty.Empty>(`/api/v1/schedules/${req["scheduledTaskId"]}/resume`, {...initReq, method: "PUT", body: JSON.stringify(req, fm.replacer)})
  }
  static ScheduleLazyIngestTask(req: ScheduleTaskRequest, initReq?: fm.InitReq): Promise<ScheduledTaskResponse> {
    return fm.fetchReq<ScheduleTaskRequest, ScheduledTaskResponse>(`/api/v1/schedules/lazy/ingestion`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static StartLazyIngestTask(req: LazyIngestRequest, initReq?: fm.InitReq): Promise<LazyIngestResponse> {
    return fm.fetchReq<LazyIngestRequest, LazyIngestResponse>(`/api/v1/schedules/lazy/ingestion/start`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static GetLazyIngestTask(req: GetLazyIngestTaskRequest, initReq?: fm.InitReq): Promise<ScheduledTaskResponse> {
    return fm.fetchReq<GetLazyIngestTaskRequest, ScheduledTaskResponse>(`/api/v1/schedules/lazy/ingestion/${req["featureSetId"]}/${req["featureSetVersion"]}?${fm.renderURLSearchParams(req, ["featureSetId", "featureSetVersion"])}`, {...initReq, method: "GET"})
  }
  static ListScheduledTaskExecutionHistory(req: ListScheduledTaskExecutionsRequest, initReq?: fm.InitReq): Promise<ListScheduledTaskExecutionsResponse> {
    return fm.fetchReq<ListScheduledTaskExecutionsRequest, ListScheduledTaskExecutionsResponse>(`/api/v1/schedules/${req["scheduledTaskId"]}/execution-history?${fm.renderURLSearchParams(req, ["scheduledTaskId"])}`, {...initReq, method: "GET"})
  }
  static GetBackfillJobOutput(req: JobId, initReq?: fm.InitReq): Promise<BackfillResponse> {
    return fm.fetchReq<JobId, BackfillResponse>(`/api/v1/jobs/${req["jobId"]}/output/backfill?${fm.renderURLSearchParams(req, ["jobId"])}`, {...initReq, method: "GET"})
  }
  static CreateDraftFeatureSet(req: FeatureSetDraftRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<FeatureSetDraftRequest, GoogleProtobufEmpty.Empty>(`/api/v1/feature-sets/draft`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static CreateMajorVersionDraftFeatureSet(req: FeatureSetMajorVersionDraftRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<FeatureSetMajorVersionDraftRequest, GoogleProtobufEmpty.Empty>(`/api/v1/feature-sets/draft-major-version`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static CreateFeatureSetFromDraft(req: DraftToFeatureSetRequest, initReq?: fm.InitReq): Promise<DraftToFeatureSetResponse> {
    return fm.fetchReq<DraftToFeatureSetRequest, DraftToFeatureSetResponse>(`/api/v1/feature-sets/draft/publish`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static CreateFeatureSetVersionFromMajorVersionDraft(req: MajorVersionDraftToFeatureSetVersionRequest, initReq?: fm.InitReq): Promise<MajorVersionDraftToFeatureSetVersionResponse> {
    return fm.fetchReq<MajorVersionDraftToFeatureSetVersionRequest, MajorVersionDraftToFeatureSetVersionResponse>(`/api/v1/feature-sets/draft-major-version/publish`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static DeleteFeatureSetDraft(req: FeatureSetDraftId, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<FeatureSetDraftId, GoogleProtobufEmpty.Empty>(`/api/v1/feature-sets/draft/${req["featureSetDraftId"]}`, {...initReq, method: "DELETE"})
  }
  static ListFeatureSetDrafts(req: ListFeatureSetDraftsRequest, initReq?: fm.InitReq): Promise<ListFeatureSetDraftsResponse> {
    return fm.fetchReq<ListFeatureSetDraftsRequest, ListFeatureSetDraftsResponse>(`/api/v1/feature-sets/draft?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GetFeatureSetDraft(req: FeatureSetDraftId, initReq?: fm.InitReq): Promise<FeatureSetDraftResponse> {
    return fm.fetchReq<FeatureSetDraftId, FeatureSetDraftResponse>(`/api/v1/feature-sets/draft/${req["featureSetDraftId"]}?${fm.renderURLSearchParams(req, ["featureSetDraftId"])}`, {...initReq, method: "GET"})
  }
  static StoreFileArtifact(req: StoreFileArtifactRequest, initReq?: fm.InitReq): Promise<StoreFileArtifactResponse> {
    return fm.fetchReq<StoreFileArtifactRequest, StoreFileArtifactResponse>(`/api/v1/artifacts/files`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static RetrieveArtifact(req: RetrieveArtifactRequest, initReq?: fm.InitReq): Promise<RetrieveArtifactResponse> {
    return fm.fetchReq<RetrieveArtifactRequest, RetrieveArtifactResponse>(`/api/v1/artifacts/${req["artifactId"]}?${fm.renderURLSearchParams(req, ["artifactId"])}`, {...initReq, method: "GET"})
  }
  static UpdateUploadStatus(req: UpdateUploadStatusRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<UpdateUploadStatusRequest, GoogleProtobufEmpty.Empty>(`/api/v1/artifacts/${req["artifactId"]}/status`, {...initReq, method: "PUT", body: JSON.stringify(req, fm.replacer)})
  }
  static DeleteArtifact(req: DeleteArtifactRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<DeleteArtifactRequest, GoogleProtobufEmpty.Empty>(`/api/v1/artifacts/${req["artifactId"]}`, {...initReq, method: "DELETE"})
  }
  static ListArtifacts(req: ListArtifactsRequest, initReq?: fm.InitReq): Promise<ListArtifactsResponse> {
    return fm.fetchReq<ListArtifactsRequest, ListArtifactsResponse>(`/api/v1/artifacts/${req["featureSetId"]}/${req["featureSetMajorVersion"]}?${fm.renderURLSearchParams(req, ["featureSetId", "featureSetMajorVersion"])}`, {...initReq, method: "GET"})
  }
  static StoreLink(req: StoreLinkRequest, initReq?: fm.InitReq): Promise<StoreLinkResponse> {
    return fm.fetchReq<StoreLinkRequest, StoreLinkResponse>(`/api/v1/artifacts/links`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
  static GetCodeSnippedId(req: CodeSnippedIdRequest, initReq?: fm.InitReq): Promise<CodeSnippedIdResponse> {
    return fm.fetchReq<CodeSnippedIdRequest, CodeSnippedIdResponse>(`/api/v1/artifacts/${req["featureSetId"]}/${req["featureSetMajorVersion"]}/code-snipped-id?${fm.renderURLSearchParams(req, ["featureSetId", "featureSetMajorVersion"])}`, {...initReq, method: "GET"})
  }
  static ListFeatureSetsToReview(req: ListFeatureSetsToReviewRequest, initReq?: fm.InitReq): Promise<ListFeatureSetsToReviewResponse> {
    return fm.fetchReq<ListFeatureSetsToReviewRequest, ListFeatureSetsToReviewResponse>(`/api/v1/reviews?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static ApproveReview(req: ApproveReviewRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<ApproveReviewRequest, GoogleProtobufEmpty.Empty>(`/api/v1/reviews/${req["reviewId"]}/approval`, {...initReq, method: "POST", body: JSON.stringify(req["reason"], fm.replacer)})
  }
  static RejectReview(req: RejectReviewRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<RejectReviewRequest, GoogleProtobufEmpty.Empty>(`/api/v1/reviews/${req["reviewId"]}/rejection`, {...initReq, method: "POST", body: JSON.stringify(req["reason"], fm.replacer)})
  }
  static ListFeatureSetsReviewsPage(req: ListFeatureSetReviewsPageRequest, initReq?: fm.InitReq): Promise<ListFeatureSetReviewsPageResponse> {
    return fm.fetchReq<ListFeatureSetReviewsPageRequest, ListFeatureSetReviewsPageResponse>(`/api/v1/reviews/my-reviews?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static GetListableFeatureSetToReview(req: GetListableFeatureSetToReviewRequest, initReq?: fm.InitReq): Promise<GetListableFeatureSetToReviewResponse> {
    return fm.fetchReq<GetListableFeatureSetToReviewRequest, GetListableFeatureSetToReviewResponse>(`/api/v1/reviews/${req["reviewId"]}/listable/feature-set?${fm.renderURLSearchParams(req, ["reviewId"])}`, {...initReq, method: "GET"})
  }
  static GetListableFeatureSetInReview(req: GetListableFeatureSetInReviewRequest, initReq?: fm.InitReq): Promise<GetListableFeatureSetInReviewResponse> {
    return fm.fetchReq<GetListableFeatureSetInReviewRequest, GetListableFeatureSetInReviewResponse>(`/api/v1/reviews/my-reviews/${req["reviewId"]}/listable/feature-set?${fm.renderURLSearchParams(req, ["reviewId"])}`, {...initReq, method: "GET"})
  }
  static DeleteFeatureSetVersionInReview(req: DeleteRejectedFeatureSetRequest, initReq?: fm.InitReq): Promise<GoogleProtobufEmpty.Empty> {
    return fm.fetchReq<DeleteRejectedFeatureSetRequest, GoogleProtobufEmpty.Empty>(`/api/v1/reviews/my-reviews/${req["reviewId"]}/feature-set`, {...initReq, method: "DELETE"})
  }
  static ListFeaturesToReview(req: ListFeaturesToReviewRequest, initReq?: fm.InitReq): Promise<ListFeaturesToReviewResponse> {
    return fm.fetchReq<ListFeaturesToReviewRequest, ListFeaturesToReviewResponse>(`/api/v1/reviews/${req["reviewId"]}/listable/feature-set/features?${fm.renderURLSearchParams(req, ["reviewId"])}`, {...initReq, method: "GET"})
  }
  static ListFeaturesInReview(req: ListFeaturesInReviewRequest, initReq?: fm.InitReq): Promise<ListFeaturesInReviewResponse> {
    return fm.fetchReq<ListFeaturesInReviewRequest, ListFeaturesInReviewResponse>(`/api/v1/reviews/my-reviews/${req["reviewId"]}/listable/feature-set/features?${fm.renderURLSearchParams(req, ["reviewId"])}`, {...initReq, method: "GET"})
  }
  static GetFeatureSetPreviewToReview(req: GetFeatureSetPreviewToReviewRequest, initReq?: fm.InitReq): Promise<GetFeatureSetPreviewToReviewResponse> {
    return fm.fetchReq<GetFeatureSetPreviewToReviewRequest, GetFeatureSetPreviewToReviewResponse>(`/api/v1/reviews/${req["reviewId"]}/feature-set/preview?${fm.renderURLSearchParams(req, ["reviewId"])}`, {...initReq, method: "GET"})
  }
  static GetFeatureSetPreviewInReview(req: GetFeatureSetPreviewInReviewRequest, initReq?: fm.InitReq): Promise<GetFeatureSetPreviewInReviewResponse> {
    return fm.fetchReq<GetFeatureSetPreviewInReviewRequest, GetFeatureSetPreviewInReviewResponse>(`/api/v1/reviews/my-reviews/${req["reviewId"]}/feature-set/preview?${fm.renderURLSearchParams(req, ["reviewId"])}`, {...initReq, method: "GET"})
  }
  static GetFeatureSetToReview(req: GetFeatureSetToReviewRequest, initReq?: fm.InitReq): Promise<GetFeatureSetToReviewResponse> {
    return fm.fetchReq<GetFeatureSetToReviewRequest, GetFeatureSetToReviewResponse>(`/api/v1/reviews/${req["reviewId"]}/feature-set?${fm.renderURLSearchParams(req, ["reviewId"])}`, {...initReq, method: "GET"})
  }
  static GetFeatureSetInReview(req: GetFeatureSetInReviewRequest, initReq?: fm.InitReq): Promise<GetFeatureSetInReviewResponse> {
    return fm.fetchReq<GetFeatureSetInReviewRequest, GetFeatureSetInReviewResponse>(`/api/v1/reviews/my-reviews/${req["reviewId"]}/feature-set?${fm.renderURLSearchParams(req, ["reviewId"])}`, {...initReq, method: "GET"})
  }
  static ListRecentGptCollections(req: ListRecentGptCollectionsRequest, initReq?: fm.InitReq): Promise<ListRecentGptCollectionsResponse> {
    return fm.fetchReq<ListRecentGptCollectionsRequest, ListRecentGptCollectionsResponse>(`/api/v1/gpte/collections?${fm.renderURLSearchParams(req, [])}`, {...initReq, method: "GET"})
  }
  static CreateGptChatSession(req: CreateGptChatSessionRequest, initReq?: fm.InitReq): Promise<CreateGptChatSessionResponse> {
    return fm.fetchReq<CreateGptChatSessionRequest, CreateGptChatSessionResponse>(`/api/v1/gpte/collections/${req["collectionId"]}/session/create`, {...initReq, method: "POST", body: JSON.stringify(req, fm.replacer)})
  }
}